/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AddressDTO,
  AddressDTOOptional,
  AddressDTOMetaI,
  AddressDTOTrackedI,
} from "./address-dto";
import { AddressDTOTracked, AddressDTOMeta } from "./address-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CardDTO,
  CardDTOOptional,
  CardDTOMetaI,
  CardDTOTrackedI,
} from "./card-dto";
import { CardDTOTracked, CardDTOMeta } from "./card-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverDTO,
  DamageWaiverDTOOptional,
  DamageWaiverDTOMetaI,
  DamageWaiverDTOTrackedI,
} from "./damage-waiver-dto";
import {
  DamageWaiverDTOTracked,
  DamageWaiverDTOMeta,
} from "./damage-waiver-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipDTO,
  MembershipDTOOptional,
  MembershipDTOMetaI,
  MembershipDTOTrackedI,
} from "./membership-dto";
import { MembershipDTOTracked, MembershipDTOMeta } from "./membership-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonInternalFull,
  PersonInternalFullOptional,
  PersonInternalFullMetaI,
  PersonInternalFullTrackedI,
} from "./person-internal-full";
import {
  PersonInternalFullTracked,
  PersonInternalFullMeta,
} from "./person-internal-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPublicMemberDTO,
  PersonPublicMemberDTOOptional,
  PersonPublicMemberDTOMetaI,
  PersonPublicMemberDTOTrackedI,
} from "./person-public-member-dto";
import {
  PersonPublicMemberDTOTracked,
  PersonPublicMemberDTOMeta,
} from "./person-public-member-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonReferralDTO,
  PersonReferralDTOOptional,
  PersonReferralDTOMetaI,
  PersonReferralDTOTrackedI,
} from "./person-referral-dto";
import {
  PersonReferralDTOTracked,
  PersonReferralDTOMeta,
} from "./person-referral-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationA,
  PersonRelationAOptional,
  PersonRelationAMetaI,
  PersonRelationATrackedI,
} from "./person-relation-a";
import {
  PersonRelationATracked,
  PersonRelationAMeta,
} from "./person-relation-a";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationB,
  PersonRelationBOptional,
  PersonRelationBMetaI,
  PersonRelationBTrackedI,
} from "./person-relation-b";
import {
  PersonRelationBTracked,
  PersonRelationBMeta,
} from "./person-relation-b";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonTypeEnum,
  PersonTypeEnumOptional,
  PersonTypeEnumMetaI,
  PersonTypeEnumTrackedI,
} from "./person-type-enum";
import { PersonTypeEnumTracked, PersonTypeEnumMeta } from "./person-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneDTO,
  PhoneDTOOptional,
  PhoneDTOMetaI,
  PhoneDTOTrackedI,
} from "./phone-dto";
import { PhoneDTOTracked, PhoneDTOMeta } from "./phone-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SwimProof,
  SwimProofOptional,
  SwimProofMetaI,
  SwimProofTrackedI,
} from "./swim-proof";
import { SwimProofTracked, SwimProofMeta } from "./swim-proof";

/**
 *
 * @export
 * @interface PersonDTO
 */
export interface PersonDTOOptional extends PersonInternalFullOptional {
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  veteranEligible?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  sailingExp?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  orgContact?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  parentEmail?: string;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  incomeLevel?: number;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  incomeAmt?: number;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  incomeAmtRaw?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  deceased?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotCall?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  employer?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  referralSource?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badPhone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  referralOther?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  jpAgeOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  sendAlert?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  ignoreJpMinAge?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  uapInterestedLessons?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  uapInterestedRides?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  entityType?: string;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  jpTeamId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  guestPortalReg?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  signoutBlockReason?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  campFair?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  dataUnconfirmed?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  protopersonCookie?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  protoState?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  memberComment?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  slackUserId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  squareCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  defaultCardId?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  allowSignouts?: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonDTO
   */
  personType?: PersonTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  allergies?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  medications?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  specialNeeds?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  occupation?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  ethnicity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  language?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  matchingGifts?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  student?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  school?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  military?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  reducedLunch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  previousMember?: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonDTO
   */
  swimProof?: SwimProof;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  dob?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  dobVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  temp?: string;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonDTO
   */
  referrals?: PersonReferralDTOOptional[];
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonDTO
   */
  phones?: PhoneDTOOptional[];
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonDTO
   */
  addresses?: AddressDTOOptional[];
  /**
   *
   * @type {Array<PersonRelationA>}
   * @memberof PersonDTO
   */
  relationsA?: PersonRelationAOptional[];
  /**
   *
   * @type {Array<PersonRelationB>}
   * @memberof PersonDTO
   */
  relationsB?: PersonRelationBOptional[];
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isLocked?: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonDTO
   */
  currentDamageWaivers?: DamageWaiverDTOOptional[];
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonDTO
   */
  currentMemberships?: MembershipDTOOptional[];
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonDTO
   */
  currentCards?: CardDTOOptional[];
}

export interface PersonDTO
  extends PersonDTOOptional, PersonInternalFull, PersonPublicMemberDTO {
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  veteranEligible?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  sailingExp?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  orgContact?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  parentEmail?: string;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  incomeLevel?: number;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  incomeAmt?: number;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  incomeAmtRaw?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  deceased?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotCall?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotMail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  employer?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  referralSource?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badPhone?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  referralOther?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  jpAgeOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  sendAlert?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  ignoreJpMinAge?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  uapInterestedLessons?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  uapInterestedRides?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  entityType?: string;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  jpTeamId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  guestPortalReg?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  signoutBlockReason?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  campFair?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  dataUnconfirmed?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  protopersonCookie?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  protoState?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  memberComment?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  slackUserId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  squareCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  defaultCardId?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  allowSignouts?: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonDTO
   */
  personType?: PersonTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  allergies?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  medications?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  specialNeeds?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  occupation?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  ethnicity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  language?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  matchingGifts?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  student?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  school?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  military?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  reducedLunch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  previousMember?: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonDTO
   */
  swimProof?: SwimProof;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  dob?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  dobVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  temp: string;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonDTO
   */
  referrals?: PersonReferralDTO[];
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonDTO
   */
  phones?: PhoneDTO[];
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonDTO
   */
  addresses?: AddressDTO[];
  /**
   *
   * @type {Array<PersonRelationA>}
   * @memberof PersonDTO
   */
  relationsA?: PersonRelationA[];
  /**
   *
   * @type {Array<PersonRelationB>}
   * @memberof PersonDTO
   */
  relationsB?: PersonRelationB[];
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isLocked?: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonDTO
   */
  currentDamageWaivers?: DamageWaiverDTO[];
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonDTO
   */
  currentMemberships?: MembershipDTO[];
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonDTO
   */
  currentCards?: CardDTO[];
}

export interface PersonDTOTrackedI extends PersonInternalFullOptional {
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  veteranEligible?: string;
  veteranEligibleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  sailingExp?: string;
  sailingExpIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  orgContact?: string;
  orgContactIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  parentEmail?: string;
  parentEmailIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  incomeLevel?: number;
  incomeLevelIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  incomeAmt?: number;
  incomeAmtIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  incomeAmtRaw?: string;
  incomeAmtRawIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badMail?: string;
  badMailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  deceased?: string;
  deceasedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotCall?: string;
  doNotCallIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotEmail?: string;
  doNotEmailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  doNotMail?: string;
  doNotMailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  employer?: string;
  employerIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  referralSource?: string;
  referralSourceIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badPhone?: string;
  badPhoneIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  badEmail?: string;
  badEmailIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  referralOther?: string;
  referralOtherIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  jpAgeOverride?: string;
  jpAgeOverrideIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  sendAlert?: string;
  sendAlertIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  ignoreJpMinAge?: string;
  ignoreJpMinAgeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  uapInterestedLessons?: string;
  uapInterestedLessonsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  uapInterestedRides?: string;
  uapInterestedRidesIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  entityType?: string;
  entityTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  jpTeamId?: number;
  jpTeamIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  guestPortalReg?: string;
  guestPortalRegIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  signoutBlockReason?: string;
  signoutBlockReasonIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  campFair?: string;
  campFairIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  dataUnconfirmed?: string;
  dataUnconfirmedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  protopersonCookie?: string;
  protopersonCookieIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  protoState?: string;
  protoStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  memberComment?: string;
  memberCommentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  slackUserId?: string;
  slackUserIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  squareCustomerId?: string;
  squareCustomerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  defaultCardId?: string;
  defaultCardIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  organization?: string;
  organizationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  email?: string;
  emailIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  allowSignouts?: boolean;
  allowSignoutsIsSet: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonDTO
   */
  personType?: PersonTypeEnum;
  personTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  allergies?: string;
  allergiesIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  medications?: string;
  medicationsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  specialNeeds?: string;
  specialNeedsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  gender?: string;
  genderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  occupation?: string;
  occupationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  citizenship?: string;
  citizenshipIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  ethnicity?: string;
  ethnicityIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  language?: string;
  languageIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  matchingGifts?: string;
  matchingGiftsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  student?: boolean;
  studentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  school?: string;
  schoolIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  military?: string;
  militaryIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  reducedLunch?: boolean;
  reducedLunchIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  previousMember?: boolean;
  previousMemberIsSet: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonDTO
   */
  swimProof?: SwimProof;
  swimProofIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  dob?: Date;
  dobIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  dobVerified?: boolean;
  dobVerifiedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  stripeCustomerId?: string;
  stripeCustomerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonDTO
   */
  temp?: string;
  tempIsSet: boolean;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonDTO
   */
  referrals?: PersonReferralDTOTrackedI[];
  referralsIsSet: boolean;
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonDTO
   */
  phones?: PhoneDTOTrackedI[];
  phonesIsSet: boolean;
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonDTO
   */
  addresses?: AddressDTOTrackedI[];
  addressesIsSet: boolean;
  /**
   *
   * @type {Array<PersonRelationA>}
   * @memberof PersonDTO
   */
  relationsA?: PersonRelationATrackedI[];
  relationsAIsSet: boolean;
  /**
   *
   * @type {Array<PersonRelationB>}
   * @memberof PersonDTO
   */
  relationsB?: PersonRelationBTrackedI[];
  relationsBIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonDTO
   */
  isLocked?: boolean;
  isLockedIsSet: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonDTO
   */
  currentDamageWaivers?: DamageWaiverDTOTrackedI[];
  currentDamageWaiversIsSet: boolean;
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonDTO
   */
  currentMemberships?: MembershipDTOTrackedI[];
  currentMembershipsIsSet: boolean;
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonDTO
   */
  currentCards?: CardDTOTrackedI[];
  currentCardsIsSet: boolean;
}

transformDatesMap.set("PersonDTO", function (model: PersonDTO) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  if (typeof model.dob == "string") model.dob = new Date(model.dob);
  const transformDatesreferrals = transformDatesMap.get("PersonReferralDTO");
  if (transformDatesreferrals) {
    model.referrals?.forEach((sub) => {
      transformDatesreferrals(sub);
    });
  }
  const transformDatesphones = transformDatesMap.get("PhoneDTO");
  if (transformDatesphones) {
    model.phones?.forEach((sub) => {
      transformDatesphones(sub);
    });
  }
  const transformDatesaddresses = transformDatesMap.get("AddressDTO");
  if (transformDatesaddresses) {
    model.addresses?.forEach((sub) => {
      transformDatesaddresses(sub);
    });
  }
  const transformDatesrelationsA = transformDatesMap.get("PersonRelationA");
  if (transformDatesrelationsA) {
    model.relationsA?.forEach((sub) => {
      transformDatesrelationsA(sub);
    });
  }
  const transformDatesrelationsB = transformDatesMap.get("PersonRelationB");
  if (transformDatesrelationsB) {
    model.relationsB?.forEach((sub) => {
      transformDatesrelationsB(sub);
    });
  }
  const transformDatescurrentDamageWaivers =
    transformDatesMap.get("DamageWaiverDTO");
  if (transformDatescurrentDamageWaivers) {
    model.currentDamageWaivers?.forEach((sub) => {
      transformDatescurrentDamageWaivers(sub);
    });
  }
  const transformDatescurrentMemberships =
    transformDatesMap.get("MembershipDTO");
  if (transformDatescurrentMemberships) {
    model.currentMemberships?.forEach((sub) => {
      transformDatescurrentMemberships(sub);
    });
  }
  const transformDatescurrentCards = transformDatesMap.get("CardDTO");
  if (transformDatescurrentCards) {
    model.currentCards?.forEach((sub) => {
      transformDatescurrentCards(sub);
    });
  }
});

export type PersonDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  veteranEligible: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sailingExp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  orgContact: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  parentEmail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  incomeLevel: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  incomeAmt: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  incomeAmtRaw: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  badMail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  deceased: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  doNotCall: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  doNotEmail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  doNotMail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  employer: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referralSource: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  badPhone: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  badEmail: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referralOther: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  jpAgeOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sendAlert: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  ignoreJpMinAge: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  uapInterestedLessons: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  uapInterestedRides: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  entityType: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  jpTeamId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  guestPortalReg: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  signoutBlockReason: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  campFair: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  dataUnconfirmed: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  protopersonCookie: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  protoState: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  memberComment: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  slackUserId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  squareCustomerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  defaultCardId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  allowSignouts: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personType: PropertyMeta<PersonTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  allergies: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  medications: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  specialNeeds: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  gender: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  occupation: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  citizenship: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  ethnicity: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  language: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  matchingGifts: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  student: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  school: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  military: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reducedLunch: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  previousMember: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  swimProof: PropertyMeta<SwimProofMetaI>;
  //isDate: false
  //isDatetime: true
  dob: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  dobVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  stripeCustomerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  temp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referrals: PropertyMeta<PersonReferralDTOMetaI>;
  //isDate: false
  //isDatetime: false
  phones: PropertyMeta<PhoneDTOMetaI>;
  //isDate: false
  //isDatetime: false
  addresses: PropertyMeta<AddressDTOMetaI>;
  //isDate: false
  //isDatetime: false
  relationsA: PropertyMeta<PersonRelationAMetaI>;
  //isDate: false
  //isDatetime: false
  relationsB: PropertyMeta<PersonRelationBMetaI>;
  //isDate: false
  //isDatetime: false
  isLocked: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  currentDamageWaivers: PropertyMeta<DamageWaiverDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentMemberships: PropertyMeta<MembershipDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentCards: PropertyMeta<CardDTOMetaI>;
}>;

export var PersonDTOMeta: PersonDTOMetaI = {} as PersonDTOMetaI;
PersonDTOMeta = typeMeta("PersonDTO", {
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  veteranEligible: propertyMeta(
    "veteranEligible",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sailingExp: propertyMeta(
    "sailingExp",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  orgContact: propertyMeta(
    "orgContact",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  parentEmail: propertyMeta(
    "parentEmail",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  incomeLevel: propertyMeta(
    "incomeLevel",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  incomeAmt: propertyMeta(
    "incomeAmt",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  incomeAmtRaw: propertyMeta(
    "incomeAmtRaw",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  badMail: propertyMeta("badMail", false, false, false, MetaTypesBase.string),
  deceased: propertyMeta("deceased", false, false, false, MetaTypesBase.string),
  doNotCall: propertyMeta(
    "doNotCall",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  doNotEmail: propertyMeta(
    "doNotEmail",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  doNotMail: propertyMeta(
    "doNotMail",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  employer: propertyMeta("employer", false, false, false, MetaTypesBase.string),
  referralSource: propertyMeta(
    "referralSource",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  badPhone: propertyMeta("badPhone", false, false, false, MetaTypesBase.string),
  badEmail: propertyMeta("badEmail", false, false, false, MetaTypesBase.string),
  referralOther: propertyMeta(
    "referralOther",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  jpAgeOverride: propertyMeta(
    "jpAgeOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sendAlert: propertyMeta(
    "sendAlert",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  ignoreJpMinAge: propertyMeta(
    "ignoreJpMinAge",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  uapInterestedLessons: propertyMeta(
    "uapInterestedLessons",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  uapInterestedRides: propertyMeta(
    "uapInterestedRides",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  entityType: propertyMeta(
    "entityType",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  jpTeamId: propertyMeta("jpTeamId", false, false, false, MetaTypesBase.number),
  guestPortalReg: propertyMeta(
    "guestPortalReg",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  signoutBlockReason: propertyMeta(
    "signoutBlockReason",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  campFair: propertyMeta("campFair", false, false, false, MetaTypesBase.string),
  dataUnconfirmed: propertyMeta(
    "dataUnconfirmed",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  protopersonCookie: propertyMeta(
    "protopersonCookie",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  protoState: propertyMeta(
    "protoState",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  memberComment: propertyMeta(
    "memberComment",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  slackUserId: propertyMeta(
    "slackUserId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  squareCustomerId: propertyMeta(
    "squareCustomerId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  defaultCardId: propertyMeta(
    "defaultCardId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  allowSignouts: propertyMeta(
    "allowSignouts",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  personType: propertyMeta(
    "personType",
    false,
    false,
    false,
    PersonTypeEnumMeta,
  ),
  allergies: propertyMeta(
    "allergies",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  medications: propertyMeta(
    "medications",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  specialNeeds: propertyMeta(
    "specialNeeds",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  gender: propertyMeta("gender", false, false, false, MetaTypesBase.string),
  occupation: propertyMeta(
    "occupation",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  citizenship: propertyMeta(
    "citizenship",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  ethnicity: propertyMeta(
    "ethnicity",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  language: propertyMeta("language", false, false, false, MetaTypesBase.string),
  matchingGifts: propertyMeta(
    "matchingGifts",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  student: propertyMeta("student", false, false, false, MetaTypesBase.boolean),
  school: propertyMeta("school", false, false, false, MetaTypesBase.string),
  military: propertyMeta("military", false, false, false, MetaTypesBase.string),
  reducedLunch: propertyMeta(
    "reducedLunch",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  previousMember: propertyMeta(
    "previousMember",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  swimProof: propertyMeta("swimProof", false, false, false, SwimProofMeta),
  dob: propertyMeta("dob", false, false, false, MetaTypesBase.Date),
  dobVerified: propertyMeta(
    "dobVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  stripeCustomerId: propertyMeta(
    "stripeCustomerId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  temp: propertyMeta("temp", false, true, false, MetaTypesBase.string),
  referrals: propertyMeta(
    "referrals",
    true,
    false,
    false,
    PersonReferralDTOMeta,
  ),
  phones: propertyMeta("phones", true, false, false, PhoneDTOMeta),
  addresses: propertyMeta("addresses", true, false, false, AddressDTOMeta),
  relationsA: propertyMeta(
    "relationsA",
    true,
    false,
    false,
    PersonRelationAMeta,
  ),
  relationsB: propertyMeta(
    "relationsB",
    true,
    false,
    false,
    PersonRelationBMeta,
  ),
  isLocked: propertyMeta(
    "isLocked",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  currentDamageWaivers: propertyMeta(
    "currentDamageWaivers",
    true,
    false,
    false,
    DamageWaiverDTOMeta,
  ),
  currentMemberships: propertyMeta(
    "currentMemberships",
    true,
    false,
    false,
    MembershipDTOMeta,
  ),
  currentCards: propertyMeta("currentCards", true, false, false, CardDTOMeta),
});

const metaI = PersonDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonInternalFullMeta]);
  metaI.updatedOn.inheritedFrom = PersonInternalFullMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = PersonInternalFullMeta.updatedBy;
  metaI.createdOn.inheritedFrom = PersonInternalFullMeta.createdOn;
  metaI.createdBy.inheritedFrom = PersonInternalFullMeta.createdBy;
  metaI.veteranEligible.inheritedFrom = PersonInternalFullMeta.veteranEligible;
  metaI.sailingExp.inheritedFrom = PersonInternalFullMeta.sailingExp;
  metaI.orgContact.inheritedFrom = PersonInternalFullMeta.orgContact;
  metaI.parentEmail.inheritedFrom = PersonInternalFullMeta.parentEmail;
  metaI.incomeLevel.inheritedFrom = PersonInternalFullMeta.incomeLevel;
  metaI.incomeAmt.inheritedFrom = PersonInternalFullMeta.incomeAmt;
  metaI.incomeAmtRaw.inheritedFrom = PersonInternalFullMeta.incomeAmtRaw;
  metaI.badMail.inheritedFrom = PersonInternalFullMeta.badMail;
  metaI.deceased.inheritedFrom = PersonInternalFullMeta.deceased;
  metaI.doNotCall.inheritedFrom = PersonInternalFullMeta.doNotCall;
  metaI.doNotEmail.inheritedFrom = PersonInternalFullMeta.doNotEmail;
  metaI.doNotMail.inheritedFrom = PersonInternalFullMeta.doNotMail;
  metaI.employer.inheritedFrom = PersonInternalFullMeta.employer;
  metaI.referralSource.inheritedFrom = PersonInternalFullMeta.referralSource;
  metaI.badPhone.inheritedFrom = PersonInternalFullMeta.badPhone;
  metaI.badEmail.inheritedFrom = PersonInternalFullMeta.badEmail;
  metaI.referralOther.inheritedFrom = PersonInternalFullMeta.referralOther;
  metaI.jpAgeOverride.inheritedFrom = PersonInternalFullMeta.jpAgeOverride;
  metaI.sendAlert.inheritedFrom = PersonInternalFullMeta.sendAlert;
  metaI.ignoreJpMinAge.inheritedFrom = PersonInternalFullMeta.ignoreJpMinAge;
  metaI.uapInterestedLessons.inheritedFrom =
    PersonInternalFullMeta.uapInterestedLessons;
  metaI.uapInterestedRides.inheritedFrom =
    PersonInternalFullMeta.uapInterestedRides;
  metaI.entityType.inheritedFrom = PersonInternalFullMeta.entityType;
  metaI.jpTeamId.inheritedFrom = PersonInternalFullMeta.jpTeamId;
  metaI.guestPortalReg.inheritedFrom = PersonInternalFullMeta.guestPortalReg;
  metaI.signoutBlockReason.inheritedFrom =
    PersonInternalFullMeta.signoutBlockReason;
  metaI.campFair.inheritedFrom = PersonInternalFullMeta.campFair;
  metaI.dataUnconfirmed.inheritedFrom = PersonInternalFullMeta.dataUnconfirmed;
  metaI.protopersonCookie.inheritedFrom =
    PersonInternalFullMeta.protopersonCookie;
  metaI.protoState.inheritedFrom = PersonInternalFullMeta.protoState;
  metaI.memberComment.inheritedFrom = PersonInternalFullMeta.memberComment;
  metaI.slackUserId.inheritedFrom = PersonInternalFullMeta.slackUserId;
  metaI.squareCustomerId.inheritedFrom =
    PersonInternalFullMeta.squareCustomerId;
  metaI.defaultCardId.inheritedFrom = PersonInternalFullMeta.defaultCardId;
  metaI.isDeleted.inheritedFrom = PersonInternalFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = PersonInternalFullMeta.isNew;
  metaI.assignId.inheritedFrom = PersonInternalFullMeta.assignId;
  metaI.prefix.inheritedFrom = PersonInternalFullMeta.prefix;
  metaI.first.inheritedFrom = PersonInternalFullMeta.first;
  metaI.middle.inheritedFrom = PersonInternalFullMeta.middle;
  metaI.last.inheritedFrom = PersonInternalFullMeta.last;
  metaI.suffix.inheritedFrom = PersonInternalFullMeta.suffix;
  metaI.preferred.inheritedFrom = PersonInternalFullMeta.preferred;
  metaI.organization.inheritedFrom = PersonInternalFullMeta.organization;
  metaI.email.inheritedFrom = PersonInternalFullMeta.email;
  metaI.allowSignouts.inheritedFrom = PersonInternalFullMeta.allowSignouts;
  metaI.personType.inheritedFrom = PersonInternalFullMeta.personType;
  metaI.allergies.inheritedFrom = PersonInternalFullMeta.allergies;
  metaI.medications.inheritedFrom = PersonInternalFullMeta.medications;
  metaI.specialNeeds.inheritedFrom = PersonInternalFullMeta.specialNeeds;
  metaI.gender.inheritedFrom = PersonInternalFullMeta.gender;
  metaI.occupation.inheritedFrom = PersonInternalFullMeta.occupation;
  metaI.citizenship.inheritedFrom = PersonInternalFullMeta.citizenship;
  metaI.ethnicity.inheritedFrom = PersonInternalFullMeta.ethnicity;
  metaI.language.inheritedFrom = PersonInternalFullMeta.language;
  metaI.matchingGifts.inheritedFrom = PersonInternalFullMeta.matchingGifts;
  metaI.student.inheritedFrom = PersonInternalFullMeta.student;
  metaI.school.inheritedFrom = PersonInternalFullMeta.school;
  metaI.military.inheritedFrom = PersonInternalFullMeta.military;
  metaI.reducedLunch.inheritedFrom = PersonInternalFullMeta.reducedLunch;
  metaI.previousMember.inheritedFrom = PersonInternalFullMeta.previousMember;
  metaI.swimProof.inheritedFrom = PersonInternalFullMeta.swimProof;
  metaI.dob.inheritedFrom = PersonInternalFullMeta.dob;
  metaI.dobVerified.inheritedFrom = PersonInternalFullMeta.dobVerified;
  metaI.stripeCustomerId.inheritedFrom =
    PersonInternalFullMeta.stripeCustomerId;
  metaI.temp.inheritedFrom = PersonInternalFullMeta.temp;
  metaI.referrals.inheritedFrom = PersonInternalFullMeta.referrals;
  metaI.phones.inheritedFrom = PersonInternalFullMeta.phones;
  metaI.addresses.inheritedFrom = PersonInternalFullMeta.addresses;
  metaI.relationsA.inheritedFrom = PersonInternalFullMeta.relationsA;
  metaI.relationsB.inheritedFrom = PersonInternalFullMeta.relationsB;
  metaI.interfaces = metaI.interfaces.concat([PersonPublicMemberDTOMeta]);
  metaI.assignId.inheritedFrom = PersonPublicMemberDTOMeta.assignId;
  metaI.prefix.inheritedFrom = PersonPublicMemberDTOMeta.prefix;
  metaI.first.inheritedFrom = PersonPublicMemberDTOMeta.first;
  metaI.middle.inheritedFrom = PersonPublicMemberDTOMeta.middle;
  metaI.last.inheritedFrom = PersonPublicMemberDTOMeta.last;
  metaI.suffix.inheritedFrom = PersonPublicMemberDTOMeta.suffix;
  metaI.preferred.inheritedFrom = PersonPublicMemberDTOMeta.preferred;
  metaI.organization.inheritedFrom = PersonPublicMemberDTOMeta.organization;
  metaI.email.inheritedFrom = PersonPublicMemberDTOMeta.email;
  metaI.allowSignouts.inheritedFrom = PersonPublicMemberDTOMeta.allowSignouts;
  metaI.personType.inheritedFrom = PersonPublicMemberDTOMeta.personType;
  metaI.allergies.inheritedFrom = PersonPublicMemberDTOMeta.allergies;
  metaI.medications.inheritedFrom = PersonPublicMemberDTOMeta.medications;
  metaI.specialNeeds.inheritedFrom = PersonPublicMemberDTOMeta.specialNeeds;
  metaI.gender.inheritedFrom = PersonPublicMemberDTOMeta.gender;
  metaI.occupation.inheritedFrom = PersonPublicMemberDTOMeta.occupation;
  metaI.citizenship.inheritedFrom = PersonPublicMemberDTOMeta.citizenship;
  metaI.ethnicity.inheritedFrom = PersonPublicMemberDTOMeta.ethnicity;
  metaI.language.inheritedFrom = PersonPublicMemberDTOMeta.language;
  metaI.matchingGifts.inheritedFrom = PersonPublicMemberDTOMeta.matchingGifts;
  metaI.student.inheritedFrom = PersonPublicMemberDTOMeta.student;
  metaI.school.inheritedFrom = PersonPublicMemberDTOMeta.school;
  metaI.military.inheritedFrom = PersonPublicMemberDTOMeta.military;
  metaI.reducedLunch.inheritedFrom = PersonPublicMemberDTOMeta.reducedLunch;
  metaI.previousMember.inheritedFrom = PersonPublicMemberDTOMeta.previousMember;
  metaI.swimProof.inheritedFrom = PersonPublicMemberDTOMeta.swimProof;
  metaI.dob.inheritedFrom = PersonPublicMemberDTOMeta.dob;
  metaI.dobVerified.inheritedFrom = PersonPublicMemberDTOMeta.dobVerified;
  metaI.stripeCustomerId.inheritedFrom =
    PersonPublicMemberDTOMeta.stripeCustomerId;
  metaI.temp.inheritedFrom = PersonPublicMemberDTOMeta.temp;
  metaI.referrals.inheritedFrom = PersonPublicMemberDTOMeta.referrals;
  metaI.phones.inheritedFrom = PersonPublicMemberDTOMeta.phones;
  metaI.addresses.inheritedFrom = PersonPublicMemberDTOMeta.addresses;
  metaI.isLocked.inheritedFrom = PersonPublicMemberDTOMeta.isLocked;
  metaI.currentDamageWaivers.inheritedFrom =
    PersonPublicMemberDTOMeta.currentDamageWaivers;
  metaI.currentMemberships.inheritedFrom =
    PersonPublicMemberDTOMeta.currentMemberships;
  metaI.currentCards.inheritedFrom = PersonPublicMemberDTOMeta.currentCards;
});

export class PersonDTOTracked
  extends PersonInternalFullTracked
  implements PersonDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  veteranEligible__I?: string = undefined;
  veteranEligibleIsSet: boolean = false;
  set veteranEligible(v: undefined | string) {
    if (v !== undefined) {
      this.veteranEligible__I = v;
      this.veteranEligibleIsSet = true;
    } else {
      this.veteranEligible__I = v || undefined;
      this.veteranEligibleIsSet = false;
    }
    this.changeTracker = true;
  }
  get veteranEligible() {
    return this.veteranEligible__I;
  }
  sailingExp__I?: string = undefined;
  sailingExpIsSet: boolean = false;
  set sailingExp(v: undefined | string) {
    if (v !== undefined) {
      this.sailingExp__I = v;
      this.sailingExpIsSet = true;
    } else {
      this.sailingExp__I = v || undefined;
      this.sailingExpIsSet = false;
    }
    this.changeTracker = true;
  }
  get sailingExp() {
    return this.sailingExp__I;
  }
  orgContact__I?: string = undefined;
  orgContactIsSet: boolean = false;
  set orgContact(v: undefined | string) {
    if (v !== undefined) {
      this.orgContact__I = v;
      this.orgContactIsSet = true;
    } else {
      this.orgContact__I = v || undefined;
      this.orgContactIsSet = false;
    }
    this.changeTracker = true;
  }
  get orgContact() {
    return this.orgContact__I;
  }
  parentEmail__I?: string = undefined;
  parentEmailIsSet: boolean = false;
  set parentEmail(v: undefined | string) {
    if (v !== undefined) {
      this.parentEmail__I = v;
      this.parentEmailIsSet = true;
    } else {
      this.parentEmail__I = v || undefined;
      this.parentEmailIsSet = false;
    }
    this.changeTracker = true;
  }
  get parentEmail() {
    return this.parentEmail__I;
  }
  incomeLevel__I?: number = undefined;
  incomeLevelIsSet: boolean = false;
  set incomeLevel(v: undefined | number) {
    if (v !== undefined) {
      this.incomeLevel__I = v;
      this.incomeLevelIsSet = true;
    } else {
      this.incomeLevel__I = v || undefined;
      this.incomeLevelIsSet = false;
    }
    this.changeTracker = true;
  }
  get incomeLevel() {
    return this.incomeLevel__I;
  }
  incomeAmt__I?: number = undefined;
  incomeAmtIsSet: boolean = false;
  set incomeAmt(v: undefined | number) {
    if (v !== undefined) {
      this.incomeAmt__I = v;
      this.incomeAmtIsSet = true;
    } else {
      this.incomeAmt__I = v || undefined;
      this.incomeAmtIsSet = false;
    }
    this.changeTracker = true;
  }
  get incomeAmt() {
    return this.incomeAmt__I;
  }
  incomeAmtRaw__I?: string = undefined;
  incomeAmtRawIsSet: boolean = false;
  set incomeAmtRaw(v: undefined | string) {
    if (v !== undefined) {
      this.incomeAmtRaw__I = v;
      this.incomeAmtRawIsSet = true;
    } else {
      this.incomeAmtRaw__I = v || undefined;
      this.incomeAmtRawIsSet = false;
    }
    this.changeTracker = true;
  }
  get incomeAmtRaw() {
    return this.incomeAmtRaw__I;
  }
  badMail__I?: string = undefined;
  badMailIsSet: boolean = false;
  set badMail(v: undefined | string) {
    if (v !== undefined) {
      this.badMail__I = v;
      this.badMailIsSet = true;
    } else {
      this.badMail__I = v || undefined;
      this.badMailIsSet = false;
    }
    this.changeTracker = true;
  }
  get badMail() {
    return this.badMail__I;
  }
  deceased__I?: string = undefined;
  deceasedIsSet: boolean = false;
  set deceased(v: undefined | string) {
    if (v !== undefined) {
      this.deceased__I = v;
      this.deceasedIsSet = true;
    } else {
      this.deceased__I = v || undefined;
      this.deceasedIsSet = false;
    }
    this.changeTracker = true;
  }
  get deceased() {
    return this.deceased__I;
  }
  doNotCall__I?: string = undefined;
  doNotCallIsSet: boolean = false;
  set doNotCall(v: undefined | string) {
    if (v !== undefined) {
      this.doNotCall__I = v;
      this.doNotCallIsSet = true;
    } else {
      this.doNotCall__I = v || undefined;
      this.doNotCallIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotCall() {
    return this.doNotCall__I;
  }
  doNotEmail__I?: string = undefined;
  doNotEmailIsSet: boolean = false;
  set doNotEmail(v: undefined | string) {
    if (v !== undefined) {
      this.doNotEmail__I = v;
      this.doNotEmailIsSet = true;
    } else {
      this.doNotEmail__I = v || undefined;
      this.doNotEmailIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotEmail() {
    return this.doNotEmail__I;
  }
  doNotMail__I?: string = undefined;
  doNotMailIsSet: boolean = false;
  set doNotMail(v: undefined | string) {
    if (v !== undefined) {
      this.doNotMail__I = v;
      this.doNotMailIsSet = true;
    } else {
      this.doNotMail__I = v || undefined;
      this.doNotMailIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotMail() {
    return this.doNotMail__I;
  }
  employer__I?: string = undefined;
  employerIsSet: boolean = false;
  set employer(v: undefined | string) {
    if (v !== undefined) {
      this.employer__I = v;
      this.employerIsSet = true;
    } else {
      this.employer__I = v || undefined;
      this.employerIsSet = false;
    }
    this.changeTracker = true;
  }
  get employer() {
    return this.employer__I;
  }
  referralSource__I?: string = undefined;
  referralSourceIsSet: boolean = false;
  set referralSource(v: undefined | string) {
    if (v !== undefined) {
      this.referralSource__I = v;
      this.referralSourceIsSet = true;
    } else {
      this.referralSource__I = v || undefined;
      this.referralSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get referralSource() {
    return this.referralSource__I;
  }
  badPhone__I?: string = undefined;
  badPhoneIsSet: boolean = false;
  set badPhone(v: undefined | string) {
    if (v !== undefined) {
      this.badPhone__I = v;
      this.badPhoneIsSet = true;
    } else {
      this.badPhone__I = v || undefined;
      this.badPhoneIsSet = false;
    }
    this.changeTracker = true;
  }
  get badPhone() {
    return this.badPhone__I;
  }
  badEmail__I?: string = undefined;
  badEmailIsSet: boolean = false;
  set badEmail(v: undefined | string) {
    if (v !== undefined) {
      this.badEmail__I = v;
      this.badEmailIsSet = true;
    } else {
      this.badEmail__I = v || undefined;
      this.badEmailIsSet = false;
    }
    this.changeTracker = true;
  }
  get badEmail() {
    return this.badEmail__I;
  }
  referralOther__I?: string = undefined;
  referralOtherIsSet: boolean = false;
  set referralOther(v: undefined | string) {
    if (v !== undefined) {
      this.referralOther__I = v;
      this.referralOtherIsSet = true;
    } else {
      this.referralOther__I = v || undefined;
      this.referralOtherIsSet = false;
    }
    this.changeTracker = true;
  }
  get referralOther() {
    return this.referralOther__I;
  }
  jpAgeOverride__I?: string = undefined;
  jpAgeOverrideIsSet: boolean = false;
  set jpAgeOverride(v: undefined | string) {
    if (v !== undefined) {
      this.jpAgeOverride__I = v;
      this.jpAgeOverrideIsSet = true;
    } else {
      this.jpAgeOverride__I = v || undefined;
      this.jpAgeOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get jpAgeOverride() {
    return this.jpAgeOverride__I;
  }
  sendAlert__I?: string = undefined;
  sendAlertIsSet: boolean = false;
  set sendAlert(v: undefined | string) {
    if (v !== undefined) {
      this.sendAlert__I = v;
      this.sendAlertIsSet = true;
    } else {
      this.sendAlert__I = v || undefined;
      this.sendAlertIsSet = false;
    }
    this.changeTracker = true;
  }
  get sendAlert() {
    return this.sendAlert__I;
  }
  ignoreJpMinAge__I?: string = undefined;
  ignoreJpMinAgeIsSet: boolean = false;
  set ignoreJpMinAge(v: undefined | string) {
    if (v !== undefined) {
      this.ignoreJpMinAge__I = v;
      this.ignoreJpMinAgeIsSet = true;
    } else {
      this.ignoreJpMinAge__I = v || undefined;
      this.ignoreJpMinAgeIsSet = false;
    }
    this.changeTracker = true;
  }
  get ignoreJpMinAge() {
    return this.ignoreJpMinAge__I;
  }
  uapInterestedLessons__I?: string = undefined;
  uapInterestedLessonsIsSet: boolean = false;
  set uapInterestedLessons(v: undefined | string) {
    if (v !== undefined) {
      this.uapInterestedLessons__I = v;
      this.uapInterestedLessonsIsSet = true;
    } else {
      this.uapInterestedLessons__I = v || undefined;
      this.uapInterestedLessonsIsSet = false;
    }
    this.changeTracker = true;
  }
  get uapInterestedLessons() {
    return this.uapInterestedLessons__I;
  }
  uapInterestedRides__I?: string = undefined;
  uapInterestedRidesIsSet: boolean = false;
  set uapInterestedRides(v: undefined | string) {
    if (v !== undefined) {
      this.uapInterestedRides__I = v;
      this.uapInterestedRidesIsSet = true;
    } else {
      this.uapInterestedRides__I = v || undefined;
      this.uapInterestedRidesIsSet = false;
    }
    this.changeTracker = true;
  }
  get uapInterestedRides() {
    return this.uapInterestedRides__I;
  }
  entityType__I?: string = undefined;
  entityTypeIsSet: boolean = false;
  set entityType(v: undefined | string) {
    if (v !== undefined) {
      this.entityType__I = v;
      this.entityTypeIsSet = true;
    } else {
      this.entityType__I = v || undefined;
      this.entityTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get entityType() {
    return this.entityType__I;
  }
  jpTeamId__I?: number = undefined;
  jpTeamIdIsSet: boolean = false;
  set jpTeamId(v: undefined | number) {
    if (v !== undefined) {
      this.jpTeamId__I = v;
      this.jpTeamIdIsSet = true;
    } else {
      this.jpTeamId__I = v || undefined;
      this.jpTeamIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get jpTeamId() {
    return this.jpTeamId__I;
  }
  guestPortalReg__I?: string = undefined;
  guestPortalRegIsSet: boolean = false;
  set guestPortalReg(v: undefined | string) {
    if (v !== undefined) {
      this.guestPortalReg__I = v;
      this.guestPortalRegIsSet = true;
    } else {
      this.guestPortalReg__I = v || undefined;
      this.guestPortalRegIsSet = false;
    }
    this.changeTracker = true;
  }
  get guestPortalReg() {
    return this.guestPortalReg__I;
  }
  signoutBlockReason__I?: string = undefined;
  signoutBlockReasonIsSet: boolean = false;
  set signoutBlockReason(v: undefined | string) {
    if (v !== undefined) {
      this.signoutBlockReason__I = v;
      this.signoutBlockReasonIsSet = true;
    } else {
      this.signoutBlockReason__I = v || undefined;
      this.signoutBlockReasonIsSet = false;
    }
    this.changeTracker = true;
  }
  get signoutBlockReason() {
    return this.signoutBlockReason__I;
  }
  campFair__I?: string = undefined;
  campFairIsSet: boolean = false;
  set campFair(v: undefined | string) {
    if (v !== undefined) {
      this.campFair__I = v;
      this.campFairIsSet = true;
    } else {
      this.campFair__I = v || undefined;
      this.campFairIsSet = false;
    }
    this.changeTracker = true;
  }
  get campFair() {
    return this.campFair__I;
  }
  dataUnconfirmed__I?: string = undefined;
  dataUnconfirmedIsSet: boolean = false;
  set dataUnconfirmed(v: undefined | string) {
    if (v !== undefined) {
      this.dataUnconfirmed__I = v;
      this.dataUnconfirmedIsSet = true;
    } else {
      this.dataUnconfirmed__I = v || undefined;
      this.dataUnconfirmedIsSet = false;
    }
    this.changeTracker = true;
  }
  get dataUnconfirmed() {
    return this.dataUnconfirmed__I;
  }
  protopersonCookie__I?: string = undefined;
  protopersonCookieIsSet: boolean = false;
  set protopersonCookie(v: undefined | string) {
    if (v !== undefined) {
      this.protopersonCookie__I = v;
      this.protopersonCookieIsSet = true;
    } else {
      this.protopersonCookie__I = v || undefined;
      this.protopersonCookieIsSet = false;
    }
    this.changeTracker = true;
  }
  get protopersonCookie() {
    return this.protopersonCookie__I;
  }
  protoState__I?: string = undefined;
  protoStateIsSet: boolean = false;
  set protoState(v: undefined | string) {
    if (v !== undefined) {
      this.protoState__I = v;
      this.protoStateIsSet = true;
    } else {
      this.protoState__I = v || undefined;
      this.protoStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get protoState() {
    return this.protoState__I;
  }
  memberComment__I?: string = undefined;
  memberCommentIsSet: boolean = false;
  set memberComment(v: undefined | string) {
    if (v !== undefined) {
      this.memberComment__I = v;
      this.memberCommentIsSet = true;
    } else {
      this.memberComment__I = v || undefined;
      this.memberCommentIsSet = false;
    }
    this.changeTracker = true;
  }
  get memberComment() {
    return this.memberComment__I;
  }
  slackUserId__I?: string = undefined;
  slackUserIdIsSet: boolean = false;
  set slackUserId(v: undefined | string) {
    if (v !== undefined) {
      this.slackUserId__I = v;
      this.slackUserIdIsSet = true;
    } else {
      this.slackUserId__I = v || undefined;
      this.slackUserIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get slackUserId() {
    return this.slackUserId__I;
  }
  squareCustomerId__I?: string = undefined;
  squareCustomerIdIsSet: boolean = false;
  set squareCustomerId(v: undefined | string) {
    if (v !== undefined) {
      this.squareCustomerId__I = v;
      this.squareCustomerIdIsSet = true;
    } else {
      this.squareCustomerId__I = v || undefined;
      this.squareCustomerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareCustomerId() {
    return this.squareCustomerId__I;
  }
  defaultCardId__I?: string = undefined;
  defaultCardIdIsSet: boolean = false;
  set defaultCardId(v: undefined | string) {
    if (v !== undefined) {
      this.defaultCardId__I = v;
      this.defaultCardIdIsSet = true;
    } else {
      this.defaultCardId__I = v || undefined;
      this.defaultCardIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get defaultCardId() {
    return this.defaultCardId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  allowSignouts__I?: boolean = undefined;
  allowSignoutsIsSet: boolean = false;
  set allowSignouts(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowSignouts__I = v;
      this.allowSignoutsIsSet = true;
    } else {
      this.allowSignouts__I = v || undefined;
      this.allowSignoutsIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowSignouts() {
    return this.allowSignouts__I;
  }
  personType__I?: PersonTypeEnum = undefined;
  personTypeIsSet: boolean = false;
  set personType(v: undefined | PersonTypeEnum) {
    if (v !== undefined) {
      this.personType__I = v;
      this.personTypeIsSet = true;
    } else {
      this.personType__I = v || undefined;
      this.personTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get personType() {
    return this.personType__I;
  }
  allergies__I?: string = undefined;
  allergiesIsSet: boolean = false;
  set allergies(v: undefined | string) {
    if (v !== undefined) {
      this.allergies__I = v;
      this.allergiesIsSet = true;
    } else {
      this.allergies__I = v || undefined;
      this.allergiesIsSet = false;
    }
    this.changeTracker = true;
  }
  get allergies() {
    return this.allergies__I;
  }
  medications__I?: string = undefined;
  medicationsIsSet: boolean = false;
  set medications(v: undefined | string) {
    if (v !== undefined) {
      this.medications__I = v;
      this.medicationsIsSet = true;
    } else {
      this.medications__I = v || undefined;
      this.medicationsIsSet = false;
    }
    this.changeTracker = true;
  }
  get medications() {
    return this.medications__I;
  }
  specialNeeds__I?: string = undefined;
  specialNeedsIsSet: boolean = false;
  set specialNeeds(v: undefined | string) {
    if (v !== undefined) {
      this.specialNeeds__I = v;
      this.specialNeedsIsSet = true;
    } else {
      this.specialNeeds__I = v || undefined;
      this.specialNeedsIsSet = false;
    }
    this.changeTracker = true;
  }
  get specialNeeds() {
    return this.specialNeeds__I;
  }
  gender__I?: string = undefined;
  genderIsSet: boolean = false;
  set gender(v: undefined | string) {
    if (v !== undefined) {
      this.gender__I = v;
      this.genderIsSet = true;
    } else {
      this.gender__I = v || undefined;
      this.genderIsSet = false;
    }
    this.changeTracker = true;
  }
  get gender() {
    return this.gender__I;
  }
  occupation__I?: string = undefined;
  occupationIsSet: boolean = false;
  set occupation(v: undefined | string) {
    if (v !== undefined) {
      this.occupation__I = v;
      this.occupationIsSet = true;
    } else {
      this.occupation__I = v || undefined;
      this.occupationIsSet = false;
    }
    this.changeTracker = true;
  }
  get occupation() {
    return this.occupation__I;
  }
  citizenship__I?: string = undefined;
  citizenshipIsSet: boolean = false;
  set citizenship(v: undefined | string) {
    if (v !== undefined) {
      this.citizenship__I = v;
      this.citizenshipIsSet = true;
    } else {
      this.citizenship__I = v || undefined;
      this.citizenshipIsSet = false;
    }
    this.changeTracker = true;
  }
  get citizenship() {
    return this.citizenship__I;
  }
  ethnicity__I?: string = undefined;
  ethnicityIsSet: boolean = false;
  set ethnicity(v: undefined | string) {
    if (v !== undefined) {
      this.ethnicity__I = v;
      this.ethnicityIsSet = true;
    } else {
      this.ethnicity__I = v || undefined;
      this.ethnicityIsSet = false;
    }
    this.changeTracker = true;
  }
  get ethnicity() {
    return this.ethnicity__I;
  }
  language__I?: string = undefined;
  languageIsSet: boolean = false;
  set language(v: undefined | string) {
    if (v !== undefined) {
      this.language__I = v;
      this.languageIsSet = true;
    } else {
      this.language__I = v || undefined;
      this.languageIsSet = false;
    }
    this.changeTracker = true;
  }
  get language() {
    return this.language__I;
  }
  matchingGifts__I?: string = undefined;
  matchingGiftsIsSet: boolean = false;
  set matchingGifts(v: undefined | string) {
    if (v !== undefined) {
      this.matchingGifts__I = v;
      this.matchingGiftsIsSet = true;
    } else {
      this.matchingGifts__I = v || undefined;
      this.matchingGiftsIsSet = false;
    }
    this.changeTracker = true;
  }
  get matchingGifts() {
    return this.matchingGifts__I;
  }
  student__I?: boolean = undefined;
  studentIsSet: boolean = false;
  set student(v: undefined | boolean) {
    if (v !== undefined) {
      this.student__I = v;
      this.studentIsSet = true;
    } else {
      this.student__I = v || undefined;
      this.studentIsSet = false;
    }
    this.changeTracker = true;
  }
  get student() {
    return this.student__I;
  }
  school__I?: string = undefined;
  schoolIsSet: boolean = false;
  set school(v: undefined | string) {
    if (v !== undefined) {
      this.school__I = v;
      this.schoolIsSet = true;
    } else {
      this.school__I = v || undefined;
      this.schoolIsSet = false;
    }
    this.changeTracker = true;
  }
  get school() {
    return this.school__I;
  }
  military__I?: string = undefined;
  militaryIsSet: boolean = false;
  set military(v: undefined | string) {
    if (v !== undefined) {
      this.military__I = v;
      this.militaryIsSet = true;
    } else {
      this.military__I = v || undefined;
      this.militaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get military() {
    return this.military__I;
  }
  reducedLunch__I?: boolean = undefined;
  reducedLunchIsSet: boolean = false;
  set reducedLunch(v: undefined | boolean) {
    if (v !== undefined) {
      this.reducedLunch__I = v;
      this.reducedLunchIsSet = true;
    } else {
      this.reducedLunch__I = v || undefined;
      this.reducedLunchIsSet = false;
    }
    this.changeTracker = true;
  }
  get reducedLunch() {
    return this.reducedLunch__I;
  }
  previousMember__I?: boolean = undefined;
  previousMemberIsSet: boolean = false;
  set previousMember(v: undefined | boolean) {
    if (v !== undefined) {
      this.previousMember__I = v;
      this.previousMemberIsSet = true;
    } else {
      this.previousMember__I = v || undefined;
      this.previousMemberIsSet = false;
    }
    this.changeTracker = true;
  }
  get previousMember() {
    return this.previousMember__I;
  }
  swimProof__I?: SwimProof = undefined;
  swimProofIsSet: boolean = false;
  set swimProof(v: undefined | SwimProof) {
    if (v !== undefined) {
      this.swimProof__I = v;
      this.swimProofIsSet = true;
    } else {
      this.swimProof__I = v || undefined;
      this.swimProofIsSet = false;
    }
    this.changeTracker = true;
  }
  get swimProof() {
    return this.swimProof__I;
  }
  dob__I?: Date = undefined;
  dobIsSet: boolean = false;
  set dob(v: undefined | Date) {
    if (v !== undefined) {
      this.dob__I = v;
      this.dobIsSet = true;
    } else {
      this.dob__I = v || undefined;
      this.dobIsSet = false;
    }
    this.changeTracker = true;
  }
  get dob() {
    return this.dob__I;
  }
  dobVerified__I?: boolean = undefined;
  dobVerifiedIsSet: boolean = false;
  set dobVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.dobVerified__I = v;
      this.dobVerifiedIsSet = true;
    } else {
      this.dobVerified__I = v || undefined;
      this.dobVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get dobVerified() {
    return this.dobVerified__I;
  }
  stripeCustomerId__I?: string = undefined;
  stripeCustomerIdIsSet: boolean = false;
  set stripeCustomerId(v: undefined | string) {
    if (v !== undefined) {
      this.stripeCustomerId__I = v;
      this.stripeCustomerIdIsSet = true;
    } else {
      this.stripeCustomerId__I = v || undefined;
      this.stripeCustomerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripeCustomerId() {
    return this.stripeCustomerId__I;
  }
  temp__I?: string = undefined;
  tempIsSet: boolean = false;
  set temp(v: undefined | string) {
    if (v !== undefined) {
      this.temp__I = v;
      this.tempIsSet = true;
    } else {
      this.temp__I = v || undefined;
      this.tempIsSet = true;
    }
    this.changeTracker = true;
  }
  get temp() {
    return this.temp__I;
  }
  referrals__I?: PersonReferralDTOTracked[] = undefined;
  referralsIsSet: boolean = false;
  set referrals(v: undefined | PersonReferralDTOTracked[]) {
    if (v !== undefined) {
      this.referrals__I = v;
      this.referralsIsSet = true;
    } else {
      this.referrals__I = v || undefined;
      this.referralsIsSet = false;
    }
    this.changeTracker = true;
  }
  get referrals() {
    return this.referrals__I;
  }
  phones__I?: PhoneDTOTracked[] = undefined;
  phonesIsSet: boolean = false;
  set phones(v: undefined | PhoneDTOTracked[]) {
    if (v !== undefined) {
      this.phones__I = v;
      this.phonesIsSet = true;
    } else {
      this.phones__I = v || undefined;
      this.phonesIsSet = false;
    }
    this.changeTracker = true;
  }
  get phones() {
    return this.phones__I;
  }
  addresses__I?: AddressDTOTracked[] = undefined;
  addressesIsSet: boolean = false;
  set addresses(v: undefined | AddressDTOTracked[]) {
    if (v !== undefined) {
      this.addresses__I = v;
      this.addressesIsSet = true;
    } else {
      this.addresses__I = v || undefined;
      this.addressesIsSet = false;
    }
    this.changeTracker = true;
  }
  get addresses() {
    return this.addresses__I;
  }
  relationsA__I?: PersonRelationATracked[] = undefined;
  relationsAIsSet: boolean = false;
  set relationsA(v: undefined | PersonRelationATracked[]) {
    if (v !== undefined) {
      this.relationsA__I = v;
      this.relationsAIsSet = true;
    } else {
      this.relationsA__I = v || undefined;
      this.relationsAIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationsA() {
    return this.relationsA__I;
  }
  relationsB__I?: PersonRelationBTracked[] = undefined;
  relationsBIsSet: boolean = false;
  set relationsB(v: undefined | PersonRelationBTracked[]) {
    if (v !== undefined) {
      this.relationsB__I = v;
      this.relationsBIsSet = true;
    } else {
      this.relationsB__I = v || undefined;
      this.relationsBIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationsB() {
    return this.relationsB__I;
  }
  isLocked__I?: boolean = undefined;
  isLockedIsSet: boolean = false;
  set isLocked(v: undefined | boolean) {
    if (v !== undefined) {
      this.isLocked__I = v;
      this.isLockedIsSet = true;
    } else {
      this.isLocked__I = v || undefined;
      this.isLockedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isLocked() {
    return this.isLocked__I;
  }
  currentDamageWaivers__I?: DamageWaiverDTOTracked[] = undefined;
  currentDamageWaiversIsSet: boolean = false;
  set currentDamageWaivers(v: undefined | DamageWaiverDTOTracked[]) {
    if (v !== undefined) {
      this.currentDamageWaivers__I = v;
      this.currentDamageWaiversIsSet = true;
    } else {
      this.currentDamageWaivers__I = v || undefined;
      this.currentDamageWaiversIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentDamageWaivers() {
    return this.currentDamageWaivers__I;
  }
  currentMemberships__I?: MembershipDTOTracked[] = undefined;
  currentMembershipsIsSet: boolean = false;
  set currentMemberships(v: undefined | MembershipDTOTracked[]) {
    if (v !== undefined) {
      this.currentMemberships__I = v;
      this.currentMembershipsIsSet = true;
    } else {
      this.currentMemberships__I = v || undefined;
      this.currentMembershipsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentMemberships() {
    return this.currentMemberships__I;
  }
  currentCards__I?: CardDTOTracked[] = undefined;
  currentCardsIsSet: boolean = false;
  set currentCards(v: undefined | CardDTOTracked[]) {
    if (v !== undefined) {
      this.currentCards__I = v;
      this.currentCardsIsSet = true;
    } else {
      this.currentCards__I = v || undefined;
      this.currentCardsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentCards() {
    return this.currentCards__I;
  }
  constructor(config?: PersonDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.referrals?.forEach((a) => a.setIds());

    this.phones?.forEach((a) => a.setIds());

    this.addresses?.forEach((a) => a.setIds());

    this.relationsA?.forEach((a) => a.setIds());

    this.relationsB?.forEach((a) => a.setIds());

    this.currentDamageWaivers?.forEach((a) => a.setIds());

    this.currentMemberships?.forEach((a) => a.setIds());

    this.currentCards?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonDTOOptional,
    options?: AssignOptions,
  ): PersonDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (
      config.veteranEligible &&
      this.veteranEligibleApplyFilter(optionsRequired.filter)
    ) {
      this.veteranEligible = config.veteranEligible;
      if (optionsRequired.unassign) this.veteranEligibleIsSet = false;
      else this.veteranEligibleIsSet = true;
    }
    if (
      config.sailingExp &&
      this.sailingExpApplyFilter(optionsRequired.filter)
    ) {
      this.sailingExp = config.sailingExp;
      if (optionsRequired.unassign) this.sailingExpIsSet = false;
      else this.sailingExpIsSet = true;
    }
    if (
      config.orgContact &&
      this.orgContactApplyFilter(optionsRequired.filter)
    ) {
      this.orgContact = config.orgContact;
      if (optionsRequired.unassign) this.orgContactIsSet = false;
      else this.orgContactIsSet = true;
    }
    if (
      config.parentEmail &&
      this.parentEmailApplyFilter(optionsRequired.filter)
    ) {
      this.parentEmail = config.parentEmail;
      if (optionsRequired.unassign) this.parentEmailIsSet = false;
      else this.parentEmailIsSet = true;
    }
    if (
      config.incomeLevel &&
      this.incomeLevelApplyFilter(optionsRequired.filter)
    ) {
      this.incomeLevel = config.incomeLevel;
      if (optionsRequired.unassign) this.incomeLevelIsSet = false;
      else this.incomeLevelIsSet = true;
    }
    if (config.incomeAmt && this.incomeAmtApplyFilter(optionsRequired.filter)) {
      this.incomeAmt = config.incomeAmt;
      if (optionsRequired.unassign) this.incomeAmtIsSet = false;
      else this.incomeAmtIsSet = true;
    }
    if (
      config.incomeAmtRaw &&
      this.incomeAmtRawApplyFilter(optionsRequired.filter)
    ) {
      this.incomeAmtRaw = config.incomeAmtRaw;
      if (optionsRequired.unassign) this.incomeAmtRawIsSet = false;
      else this.incomeAmtRawIsSet = true;
    }
    if (config.badMail && this.badMailApplyFilter(optionsRequired.filter)) {
      this.badMail = config.badMail;
      if (optionsRequired.unassign) this.badMailIsSet = false;
      else this.badMailIsSet = true;
    }
    if (config.deceased && this.deceasedApplyFilter(optionsRequired.filter)) {
      this.deceased = config.deceased;
      if (optionsRequired.unassign) this.deceasedIsSet = false;
      else this.deceasedIsSet = true;
    }
    if (config.doNotCall && this.doNotCallApplyFilter(optionsRequired.filter)) {
      this.doNotCall = config.doNotCall;
      if (optionsRequired.unassign) this.doNotCallIsSet = false;
      else this.doNotCallIsSet = true;
    }
    if (
      config.doNotEmail &&
      this.doNotEmailApplyFilter(optionsRequired.filter)
    ) {
      this.doNotEmail = config.doNotEmail;
      if (optionsRequired.unassign) this.doNotEmailIsSet = false;
      else this.doNotEmailIsSet = true;
    }
    if (config.doNotMail && this.doNotMailApplyFilter(optionsRequired.filter)) {
      this.doNotMail = config.doNotMail;
      if (optionsRequired.unassign) this.doNotMailIsSet = false;
      else this.doNotMailIsSet = true;
    }
    if (config.employer && this.employerApplyFilter(optionsRequired.filter)) {
      this.employer = config.employer;
      if (optionsRequired.unassign) this.employerIsSet = false;
      else this.employerIsSet = true;
    }
    if (
      config.referralSource &&
      this.referralSourceApplyFilter(optionsRequired.filter)
    ) {
      this.referralSource = config.referralSource;
      if (optionsRequired.unassign) this.referralSourceIsSet = false;
      else this.referralSourceIsSet = true;
    }
    if (config.badPhone && this.badPhoneApplyFilter(optionsRequired.filter)) {
      this.badPhone = config.badPhone;
      if (optionsRequired.unassign) this.badPhoneIsSet = false;
      else this.badPhoneIsSet = true;
    }
    if (config.badEmail && this.badEmailApplyFilter(optionsRequired.filter)) {
      this.badEmail = config.badEmail;
      if (optionsRequired.unassign) this.badEmailIsSet = false;
      else this.badEmailIsSet = true;
    }
    if (
      config.referralOther &&
      this.referralOtherApplyFilter(optionsRequired.filter)
    ) {
      this.referralOther = config.referralOther;
      if (optionsRequired.unassign) this.referralOtherIsSet = false;
      else this.referralOtherIsSet = true;
    }
    if (
      config.jpAgeOverride &&
      this.jpAgeOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.jpAgeOverride = config.jpAgeOverride;
      if (optionsRequired.unassign) this.jpAgeOverrideIsSet = false;
      else this.jpAgeOverrideIsSet = true;
    }
    if (config.sendAlert && this.sendAlertApplyFilter(optionsRequired.filter)) {
      this.sendAlert = config.sendAlert;
      if (optionsRequired.unassign) this.sendAlertIsSet = false;
      else this.sendAlertIsSet = true;
    }
    if (
      config.ignoreJpMinAge &&
      this.ignoreJpMinAgeApplyFilter(optionsRequired.filter)
    ) {
      this.ignoreJpMinAge = config.ignoreJpMinAge;
      if (optionsRequired.unassign) this.ignoreJpMinAgeIsSet = false;
      else this.ignoreJpMinAgeIsSet = true;
    }
    if (
      config.uapInterestedLessons &&
      this.uapInterestedLessonsApplyFilter(optionsRequired.filter)
    ) {
      this.uapInterestedLessons = config.uapInterestedLessons;
      if (optionsRequired.unassign) this.uapInterestedLessonsIsSet = false;
      else this.uapInterestedLessonsIsSet = true;
    }
    if (
      config.uapInterestedRides &&
      this.uapInterestedRidesApplyFilter(optionsRequired.filter)
    ) {
      this.uapInterestedRides = config.uapInterestedRides;
      if (optionsRequired.unassign) this.uapInterestedRidesIsSet = false;
      else this.uapInterestedRidesIsSet = true;
    }
    if (
      config.entityType &&
      this.entityTypeApplyFilter(optionsRequired.filter)
    ) {
      this.entityType = config.entityType;
      if (optionsRequired.unassign) this.entityTypeIsSet = false;
      else this.entityTypeIsSet = true;
    }
    if (config.jpTeamId && this.jpTeamIdApplyFilter(optionsRequired.filter)) {
      this.jpTeamId = config.jpTeamId;
      if (optionsRequired.unassign) this.jpTeamIdIsSet = false;
      else this.jpTeamIdIsSet = true;
    }
    if (
      config.guestPortalReg &&
      this.guestPortalRegApplyFilter(optionsRequired.filter)
    ) {
      this.guestPortalReg = config.guestPortalReg;
      if (optionsRequired.unassign) this.guestPortalRegIsSet = false;
      else this.guestPortalRegIsSet = true;
    }
    if (
      config.signoutBlockReason &&
      this.signoutBlockReasonApplyFilter(optionsRequired.filter)
    ) {
      this.signoutBlockReason = config.signoutBlockReason;
      if (optionsRequired.unassign) this.signoutBlockReasonIsSet = false;
      else this.signoutBlockReasonIsSet = true;
    }
    if (config.campFair && this.campFairApplyFilter(optionsRequired.filter)) {
      this.campFair = config.campFair;
      if (optionsRequired.unassign) this.campFairIsSet = false;
      else this.campFairIsSet = true;
    }
    if (
      config.dataUnconfirmed &&
      this.dataUnconfirmedApplyFilter(optionsRequired.filter)
    ) {
      this.dataUnconfirmed = config.dataUnconfirmed;
      if (optionsRequired.unassign) this.dataUnconfirmedIsSet = false;
      else this.dataUnconfirmedIsSet = true;
    }
    if (
      config.protopersonCookie &&
      this.protopersonCookieApplyFilter(optionsRequired.filter)
    ) {
      this.protopersonCookie = config.protopersonCookie;
      if (optionsRequired.unassign) this.protopersonCookieIsSet = false;
      else this.protopersonCookieIsSet = true;
    }
    if (
      config.protoState &&
      this.protoStateApplyFilter(optionsRequired.filter)
    ) {
      this.protoState = config.protoState;
      if (optionsRequired.unassign) this.protoStateIsSet = false;
      else this.protoStateIsSet = true;
    }
    if (
      config.memberComment &&
      this.memberCommentApplyFilter(optionsRequired.filter)
    ) {
      this.memberComment = config.memberComment;
      if (optionsRequired.unassign) this.memberCommentIsSet = false;
      else this.memberCommentIsSet = true;
    }
    if (
      config.slackUserId &&
      this.slackUserIdApplyFilter(optionsRequired.filter)
    ) {
      this.slackUserId = config.slackUserId;
      if (optionsRequired.unassign) this.slackUserIdIsSet = false;
      else this.slackUserIdIsSet = true;
    }
    if (
      config.squareCustomerId &&
      this.squareCustomerIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareCustomerId = config.squareCustomerId;
      if (optionsRequired.unassign) this.squareCustomerIdIsSet = false;
      else this.squareCustomerIdIsSet = true;
    }
    if (
      config.defaultCardId &&
      this.defaultCardIdApplyFilter(optionsRequired.filter)
    ) {
      this.defaultCardId = config.defaultCardId;
      if (optionsRequired.unassign) this.defaultCardIdIsSet = false;
      else this.defaultCardIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (
      config.allowSignouts &&
      this.allowSignoutsApplyFilter(optionsRequired.filter)
    ) {
      this.allowSignouts = config.allowSignouts;
      if (optionsRequired.unassign) this.allowSignoutsIsSet = false;
      else this.allowSignoutsIsSet = true;
    }
    if (
      config.personType &&
      this.personTypeApplyFilter(optionsRequired.filter)
    ) {
      this.personType = config.personType;
      if (optionsRequired.unassign) this.personTypeIsSet = false;
      else this.personTypeIsSet = true;
    }
    if (config.allergies && this.allergiesApplyFilter(optionsRequired.filter)) {
      this.allergies = config.allergies;
      if (optionsRequired.unassign) this.allergiesIsSet = false;
      else this.allergiesIsSet = true;
    }
    if (
      config.medications &&
      this.medicationsApplyFilter(optionsRequired.filter)
    ) {
      this.medications = config.medications;
      if (optionsRequired.unassign) this.medicationsIsSet = false;
      else this.medicationsIsSet = true;
    }
    if (
      config.specialNeeds &&
      this.specialNeedsApplyFilter(optionsRequired.filter)
    ) {
      this.specialNeeds = config.specialNeeds;
      if (optionsRequired.unassign) this.specialNeedsIsSet = false;
      else this.specialNeedsIsSet = true;
    }
    if (config.gender && this.genderApplyFilter(optionsRequired.filter)) {
      this.gender = config.gender;
      if (optionsRequired.unassign) this.genderIsSet = false;
      else this.genderIsSet = true;
    }
    if (
      config.occupation &&
      this.occupationApplyFilter(optionsRequired.filter)
    ) {
      this.occupation = config.occupation;
      if (optionsRequired.unassign) this.occupationIsSet = false;
      else this.occupationIsSet = true;
    }
    if (
      config.citizenship &&
      this.citizenshipApplyFilter(optionsRequired.filter)
    ) {
      this.citizenship = config.citizenship;
      if (optionsRequired.unassign) this.citizenshipIsSet = false;
      else this.citizenshipIsSet = true;
    }
    if (config.ethnicity && this.ethnicityApplyFilter(optionsRequired.filter)) {
      this.ethnicity = config.ethnicity;
      if (optionsRequired.unassign) this.ethnicityIsSet = false;
      else this.ethnicityIsSet = true;
    }
    if (config.language && this.languageApplyFilter(optionsRequired.filter)) {
      this.language = config.language;
      if (optionsRequired.unassign) this.languageIsSet = false;
      else this.languageIsSet = true;
    }
    if (
      config.matchingGifts &&
      this.matchingGiftsApplyFilter(optionsRequired.filter)
    ) {
      this.matchingGifts = config.matchingGifts;
      if (optionsRequired.unassign) this.matchingGiftsIsSet = false;
      else this.matchingGiftsIsSet = true;
    }
    if (config.student && this.studentApplyFilter(optionsRequired.filter)) {
      this.student = config.student;
      if (optionsRequired.unassign) this.studentIsSet = false;
      else this.studentIsSet = true;
    }
    if (config.school && this.schoolApplyFilter(optionsRequired.filter)) {
      this.school = config.school;
      if (optionsRequired.unassign) this.schoolIsSet = false;
      else this.schoolIsSet = true;
    }
    if (config.military && this.militaryApplyFilter(optionsRequired.filter)) {
      this.military = config.military;
      if (optionsRequired.unassign) this.militaryIsSet = false;
      else this.militaryIsSet = true;
    }
    if (
      config.reducedLunch &&
      this.reducedLunchApplyFilter(optionsRequired.filter)
    ) {
      this.reducedLunch = config.reducedLunch;
      if (optionsRequired.unassign) this.reducedLunchIsSet = false;
      else this.reducedLunchIsSet = true;
    }
    if (
      config.previousMember &&
      this.previousMemberApplyFilter(optionsRequired.filter)
    ) {
      this.previousMember = config.previousMember;
      if (optionsRequired.unassign) this.previousMemberIsSet = false;
      else this.previousMemberIsSet = true;
    }
    if (config.swimProof && this.swimProofApplyFilter(optionsRequired.filter)) {
      this.swimProof = config.swimProof;
      if (optionsRequired.unassign) this.swimProofIsSet = false;
      else this.swimProofIsSet = true;
    }
    if (config.dob && this.dobApplyFilter(optionsRequired.filter)) {
      this.dob = config.dob;
      if (optionsRequired.unassign) this.dobIsSet = false;
      else this.dobIsSet = true;
    }
    if (
      config.dobVerified &&
      this.dobVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.dobVerified = config.dobVerified;
      if (optionsRequired.unassign) this.dobVerifiedIsSet = false;
      else this.dobVerifiedIsSet = true;
    }
    if (
      config.stripeCustomerId &&
      this.stripeCustomerIdApplyFilter(optionsRequired.filter)
    ) {
      this.stripeCustomerId = config.stripeCustomerId;
      if (optionsRequired.unassign) this.stripeCustomerIdIsSet = false;
      else this.stripeCustomerIdIsSet = true;
    }
    if (config.temp && this.tempApplyFilter(optionsRequired.filter)) {
      this.temp = config.temp;
      if (optionsRequired.unassign) this.tempIsSet = false;
      else this.tempIsSet = true;
    }
    if (config.referrals && this.referralsApplyFilter(optionsRequired.filter)) {
      this.referrals = config.referrals?.map(
        (a) => new PersonReferralDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.referralsIsSet = false;
      else this.referralsIsSet = true;
    }
    if (config.phones && this.phonesApplyFilter(optionsRequired.filter)) {
      this.phones = config.phones?.map((a) => new PhoneDTOTracked(a, options));
      if (optionsRequired.unassign) this.phonesIsSet = false;
      else this.phonesIsSet = true;
    }
    if (config.addresses && this.addressesApplyFilter(optionsRequired.filter)) {
      this.addresses = config.addresses?.map(
        (a) => new AddressDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.addressesIsSet = false;
      else this.addressesIsSet = true;
    }
    if (
      config.relationsA &&
      this.relationsAApplyFilter(optionsRequired.filter)
    ) {
      this.relationsA = config.relationsA?.map(
        (a) => new PersonRelationATracked(a, options),
      );
      if (optionsRequired.unassign) this.relationsAIsSet = false;
      else this.relationsAIsSet = true;
    }
    if (
      config.relationsB &&
      this.relationsBApplyFilter(optionsRequired.filter)
    ) {
      this.relationsB = config.relationsB?.map(
        (a) => new PersonRelationBTracked(a, options),
      );
      if (optionsRequired.unassign) this.relationsBIsSet = false;
      else this.relationsBIsSet = true;
    }
    if (config.isLocked && this.isLockedApplyFilter(optionsRequired.filter)) {
      this.isLocked = config.isLocked;
      if (optionsRequired.unassign) this.isLockedIsSet = false;
      else this.isLockedIsSet = true;
    }
    if (
      config.currentDamageWaivers &&
      this.currentDamageWaiversApplyFilter(optionsRequired.filter)
    ) {
      this.currentDamageWaivers = config.currentDamageWaivers?.map(
        (a) => new DamageWaiverDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentDamageWaiversIsSet = false;
      else this.currentDamageWaiversIsSet = true;
    }
    if (
      config.currentMemberships &&
      this.currentMembershipsApplyFilter(optionsRequired.filter)
    ) {
      this.currentMemberships = config.currentMemberships?.map(
        (a) => new MembershipDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentMembershipsIsSet = false;
      else this.currentMembershipsIsSet = true;
    }
    if (
      config.currentCards &&
      this.currentCardsApplyFilter(optionsRequired.filter)
    ) {
      this.currentCards = config.currentCards?.map(
        (a) => new CardDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentCardsIsSet = false;
      else this.currentCardsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonDTOTrackedI {
    const cloned = {} as PersonDTOTrackedI;
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.veteranEligibleIsSetDeep() &&
      this.veteranEligibleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.veteranEligibleIsSet = true;
      cloned.veteranEligible = this.veteranEligible;
    } else {
      //cloned.veteranEligibleIsSet = false
    }
    if (
      this.sailingExpIsSetDeep() &&
      this.sailingExpApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sailingExpIsSet = true;
      cloned.sailingExp = this.sailingExp;
    } else {
      //cloned.sailingExpIsSet = false
    }
    if (
      this.orgContactIsSetDeep() &&
      this.orgContactApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orgContactIsSet = true;
      cloned.orgContact = this.orgContact;
    } else {
      //cloned.orgContactIsSet = false
    }
    if (
      this.parentEmailIsSetDeep() &&
      this.parentEmailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.parentEmailIsSet = true;
      cloned.parentEmail = this.parentEmail;
    } else {
      //cloned.parentEmailIsSet = false
    }
    if (
      this.incomeLevelIsSetDeep() &&
      this.incomeLevelApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.incomeLevelIsSet = true;
      cloned.incomeLevel = this.incomeLevel;
    } else {
      //cloned.incomeLevelIsSet = false
    }
    if (
      this.incomeAmtIsSetDeep() &&
      this.incomeAmtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.incomeAmtIsSet = true;
      cloned.incomeAmt = this.incomeAmt;
    } else {
      //cloned.incomeAmtIsSet = false
    }
    if (
      this.incomeAmtRawIsSetDeep() &&
      this.incomeAmtRawApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.incomeAmtRawIsSet = true;
      cloned.incomeAmtRaw = this.incomeAmtRaw;
    } else {
      //cloned.incomeAmtRawIsSet = false
    }
    if (
      this.badMailIsSetDeep() &&
      this.badMailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badMailIsSet = true;
      cloned.badMail = this.badMail;
    } else {
      //cloned.badMailIsSet = false
    }
    if (
      this.deceasedIsSetDeep() &&
      this.deceasedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.deceasedIsSet = true;
      cloned.deceased = this.deceased;
    } else {
      //cloned.deceasedIsSet = false
    }
    if (
      this.doNotCallIsSetDeep() &&
      this.doNotCallApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotCallIsSet = true;
      cloned.doNotCall = this.doNotCall;
    } else {
      //cloned.doNotCallIsSet = false
    }
    if (
      this.doNotEmailIsSetDeep() &&
      this.doNotEmailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotEmailIsSet = true;
      cloned.doNotEmail = this.doNotEmail;
    } else {
      //cloned.doNotEmailIsSet = false
    }
    if (
      this.doNotMailIsSetDeep() &&
      this.doNotMailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotMailIsSet = true;
      cloned.doNotMail = this.doNotMail;
    } else {
      //cloned.doNotMailIsSet = false
    }
    if (
      this.employerIsSetDeep() &&
      this.employerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.employerIsSet = true;
      cloned.employer = this.employer;
    } else {
      //cloned.employerIsSet = false
    }
    if (
      this.referralSourceIsSetDeep() &&
      this.referralSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralSourceIsSet = true;
      cloned.referralSource = this.referralSource;
    } else {
      //cloned.referralSourceIsSet = false
    }
    if (
      this.badPhoneIsSetDeep() &&
      this.badPhoneApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badPhoneIsSet = true;
      cloned.badPhone = this.badPhone;
    } else {
      //cloned.badPhoneIsSet = false
    }
    if (
      this.badEmailIsSetDeep() &&
      this.badEmailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badEmailIsSet = true;
      cloned.badEmail = this.badEmail;
    } else {
      //cloned.badEmailIsSet = false
    }
    if (
      this.referralOtherIsSetDeep() &&
      this.referralOtherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralOtherIsSet = true;
      cloned.referralOther = this.referralOther;
    } else {
      //cloned.referralOtherIsSet = false
    }
    if (
      this.jpAgeOverrideIsSetDeep() &&
      this.jpAgeOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.jpAgeOverrideIsSet = true;
      cloned.jpAgeOverride = this.jpAgeOverride;
    } else {
      //cloned.jpAgeOverrideIsSet = false
    }
    if (
      this.sendAlertIsSetDeep() &&
      this.sendAlertApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sendAlertIsSet = true;
      cloned.sendAlert = this.sendAlert;
    } else {
      //cloned.sendAlertIsSet = false
    }
    if (
      this.ignoreJpMinAgeIsSetDeep() &&
      this.ignoreJpMinAgeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ignoreJpMinAgeIsSet = true;
      cloned.ignoreJpMinAge = this.ignoreJpMinAge;
    } else {
      //cloned.ignoreJpMinAgeIsSet = false
    }
    if (
      this.uapInterestedLessonsIsSetDeep() &&
      this.uapInterestedLessonsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.uapInterestedLessonsIsSet = true;
      cloned.uapInterestedLessons = this.uapInterestedLessons;
    } else {
      //cloned.uapInterestedLessonsIsSet = false
    }
    if (
      this.uapInterestedRidesIsSetDeep() &&
      this.uapInterestedRidesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.uapInterestedRidesIsSet = true;
      cloned.uapInterestedRides = this.uapInterestedRides;
    } else {
      //cloned.uapInterestedRidesIsSet = false
    }
    if (
      this.entityTypeIsSetDeep() &&
      this.entityTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.entityTypeIsSet = true;
      cloned.entityType = this.entityType;
    } else {
      //cloned.entityTypeIsSet = false
    }
    if (
      this.jpTeamIdIsSetDeep() &&
      this.jpTeamIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.jpTeamIdIsSet = true;
      cloned.jpTeamId = this.jpTeamId;
    } else {
      //cloned.jpTeamIdIsSet = false
    }
    if (
      this.guestPortalRegIsSetDeep() &&
      this.guestPortalRegApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.guestPortalRegIsSet = true;
      cloned.guestPortalReg = this.guestPortalReg;
    } else {
      //cloned.guestPortalRegIsSet = false
    }
    if (
      this.signoutBlockReasonIsSetDeep() &&
      this.signoutBlockReasonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signoutBlockReasonIsSet = true;
      cloned.signoutBlockReason = this.signoutBlockReason;
    } else {
      //cloned.signoutBlockReasonIsSet = false
    }
    if (
      this.campFairIsSetDeep() &&
      this.campFairApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.campFairIsSet = true;
      cloned.campFair = this.campFair;
    } else {
      //cloned.campFairIsSet = false
    }
    if (
      this.dataUnconfirmedIsSetDeep() &&
      this.dataUnconfirmedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dataUnconfirmedIsSet = true;
      cloned.dataUnconfirmed = this.dataUnconfirmed;
    } else {
      //cloned.dataUnconfirmedIsSet = false
    }
    if (
      this.protopersonCookieIsSetDeep() &&
      this.protopersonCookieApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.protopersonCookieIsSet = true;
      cloned.protopersonCookie = this.protopersonCookie;
    } else {
      //cloned.protopersonCookieIsSet = false
    }
    if (
      this.protoStateIsSetDeep() &&
      this.protoStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.protoStateIsSet = true;
      cloned.protoState = this.protoState;
    } else {
      //cloned.protoStateIsSet = false
    }
    if (
      this.memberCommentIsSetDeep() &&
      this.memberCommentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.memberCommentIsSet = true;
      cloned.memberComment = this.memberComment;
    } else {
      //cloned.memberCommentIsSet = false
    }
    if (
      this.slackUserIdIsSetDeep() &&
      this.slackUserIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.slackUserIdIsSet = true;
      cloned.slackUserId = this.slackUserId;
    } else {
      //cloned.slackUserIdIsSet = false
    }
    if (
      this.squareCustomerIdIsSetDeep() &&
      this.squareCustomerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareCustomerIdIsSet = true;
      cloned.squareCustomerId = this.squareCustomerId;
    } else {
      //cloned.squareCustomerIdIsSet = false
    }
    if (
      this.defaultCardIdIsSetDeep() &&
      this.defaultCardIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.defaultCardIdIsSet = true;
      cloned.defaultCardId = this.defaultCardId;
    } else {
      //cloned.defaultCardIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    if (
      this.allowSignoutsIsSetDeep() &&
      this.allowSignoutsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowSignoutsIsSet = true;
      cloned.allowSignouts = this.allowSignouts;
    } else {
      //cloned.allowSignoutsIsSet = false
    }
    if (
      this.personTypeIsSetDeep() &&
      this.personTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personTypeIsSet = true;
      cloned.personType = this.personType;
    } else {
      //cloned.personTypeIsSet = false
    }
    if (
      this.allergiesIsSetDeep() &&
      this.allergiesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allergiesIsSet = true;
      cloned.allergies = this.allergies;
    } else {
      //cloned.allergiesIsSet = false
    }
    if (
      this.medicationsIsSetDeep() &&
      this.medicationsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.medicationsIsSet = true;
      cloned.medications = this.medications;
    } else {
      //cloned.medicationsIsSet = false
    }
    if (
      this.specialNeedsIsSetDeep() &&
      this.specialNeedsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specialNeedsIsSet = true;
      cloned.specialNeeds = this.specialNeeds;
    } else {
      //cloned.specialNeedsIsSet = false
    }
    if (
      this.genderIsSetDeep() &&
      this.genderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.genderIsSet = true;
      cloned.gender = this.gender;
    } else {
      //cloned.genderIsSet = false
    }
    if (
      this.occupationIsSetDeep() &&
      this.occupationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.occupationIsSet = true;
      cloned.occupation = this.occupation;
    } else {
      //cloned.occupationIsSet = false
    }
    if (
      this.citizenshipIsSetDeep() &&
      this.citizenshipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.citizenshipIsSet = true;
      cloned.citizenship = this.citizenship;
    } else {
      //cloned.citizenshipIsSet = false
    }
    if (
      this.ethnicityIsSetDeep() &&
      this.ethnicityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ethnicityIsSet = true;
      cloned.ethnicity = this.ethnicity;
    } else {
      //cloned.ethnicityIsSet = false
    }
    if (
      this.languageIsSetDeep() &&
      this.languageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.languageIsSet = true;
      cloned.language = this.language;
    } else {
      //cloned.languageIsSet = false
    }
    if (
      this.matchingGiftsIsSetDeep() &&
      this.matchingGiftsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.matchingGiftsIsSet = true;
      cloned.matchingGifts = this.matchingGifts;
    } else {
      //cloned.matchingGiftsIsSet = false
    }
    if (
      this.studentIsSetDeep() &&
      this.studentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.studentIsSet = true;
      cloned.student = this.student;
    } else {
      //cloned.studentIsSet = false
    }
    if (
      this.schoolIsSetDeep() &&
      this.schoolApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.schoolIsSet = true;
      cloned.school = this.school;
    } else {
      //cloned.schoolIsSet = false
    }
    if (
      this.militaryIsSetDeep() &&
      this.militaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.militaryIsSet = true;
      cloned.military = this.military;
    } else {
      //cloned.militaryIsSet = false
    }
    if (
      this.reducedLunchIsSetDeep() &&
      this.reducedLunchApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reducedLunchIsSet = true;
      cloned.reducedLunch = this.reducedLunch;
    } else {
      //cloned.reducedLunchIsSet = false
    }
    if (
      this.previousMemberIsSetDeep() &&
      this.previousMemberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.previousMemberIsSet = true;
      cloned.previousMember = this.previousMember;
    } else {
      //cloned.previousMemberIsSet = false
    }
    if (
      this.swimProofIsSetDeep() &&
      this.swimProofApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.swimProofIsSet = true;
      cloned.swimProof = this.swimProof;
    } else {
      //cloned.swimProofIsSet = false
    }
    if (
      this.dobIsSetDeep() &&
      this.dobApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dobIsSet = true;
      cloned.dob = this.dob;
    } else {
      //cloned.dobIsSet = false
    }
    if (
      this.dobVerifiedIsSetDeep() &&
      this.dobVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dobVerifiedIsSet = true;
      cloned.dobVerified = this.dobVerified;
    } else {
      //cloned.dobVerifiedIsSet = false
    }
    if (
      this.stripeCustomerIdIsSetDeep() &&
      this.stripeCustomerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripeCustomerIdIsSet = true;
      cloned.stripeCustomerId = this.stripeCustomerId;
    } else {
      //cloned.stripeCustomerIdIsSet = false
    }
    if (
      this.tempIsSetDeep() &&
      this.tempApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIsSet = true;
      cloned.temp = this.temp;
    } else {
      //cloned.tempIsSet = false
    }
    if (
      this.referralsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.referralsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralsIsSet = true;
      cloned.referrals = this.referrals
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.referralsIsSet = false
    }
    if (
      this.phonesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.phonesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.phonesIsSet = true;
      cloned.phones = this.phones
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.phonesIsSet = false
    }
    if (
      this.addressesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.addressesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.addressesIsSet = true;
      cloned.addresses = this.addresses
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.addressesIsSet = false
    }
    if (
      this.relationsAIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.relationsAApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationsAIsSet = true;
      cloned.relationsA = this.relationsA
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.relationsAIsSet = false
    }
    if (
      this.relationsBIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.relationsBApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationsBIsSet = true;
      cloned.relationsB = this.relationsB
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.relationsBIsSet = false
    }
    if (
      this.isLockedIsSetDeep() &&
      this.isLockedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isLockedIsSet = true;
      cloned.isLocked = this.isLocked;
    } else {
      //cloned.isLockedIsSet = false
    }
    if (
      this.currentDamageWaiversIsSetDeep(
        (a, b) => !a.isPrimary || !b.isArray,
      ) &&
      this.currentDamageWaiversApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentDamageWaiversIsSet = true;
      cloned.currentDamageWaivers = this.currentDamageWaivers
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentDamageWaiversIsSet = false
    }
    if (
      this.currentMembershipsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.currentMembershipsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentMembershipsIsSet = true;
      cloned.currentMemberships = this.currentMemberships
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentMembershipsIsSet = false
    }
    if (
      this.currentCardsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.currentCardsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentCardsIsSet = true;
      cloned.currentCards = this.currentCards
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentCardsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonDTOTrackedI {
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.veteranEligibleApplyFilter(filter))
      this.veteranEligibleIsSet = false;

    if (!this.sailingExpApplyFilter(filter)) this.sailingExpIsSet = false;

    if (!this.orgContactApplyFilter(filter)) this.orgContactIsSet = false;

    if (!this.parentEmailApplyFilter(filter)) this.parentEmailIsSet = false;

    if (!this.incomeLevelApplyFilter(filter)) this.incomeLevelIsSet = false;

    if (!this.incomeAmtApplyFilter(filter)) this.incomeAmtIsSet = false;

    if (!this.incomeAmtRawApplyFilter(filter)) this.incomeAmtRawIsSet = false;

    if (!this.badMailApplyFilter(filter)) this.badMailIsSet = false;

    if (!this.deceasedApplyFilter(filter)) this.deceasedIsSet = false;

    if (!this.doNotCallApplyFilter(filter)) this.doNotCallIsSet = false;

    if (!this.doNotEmailApplyFilter(filter)) this.doNotEmailIsSet = false;

    if (!this.doNotMailApplyFilter(filter)) this.doNotMailIsSet = false;

    if (!this.employerApplyFilter(filter)) this.employerIsSet = false;

    if (!this.referralSourceApplyFilter(filter))
      this.referralSourceIsSet = false;

    if (!this.badPhoneApplyFilter(filter)) this.badPhoneIsSet = false;

    if (!this.badEmailApplyFilter(filter)) this.badEmailIsSet = false;

    if (!this.referralOtherApplyFilter(filter)) this.referralOtherIsSet = false;

    if (!this.jpAgeOverrideApplyFilter(filter)) this.jpAgeOverrideIsSet = false;

    if (!this.sendAlertApplyFilter(filter)) this.sendAlertIsSet = false;

    if (!this.ignoreJpMinAgeApplyFilter(filter))
      this.ignoreJpMinAgeIsSet = false;

    if (!this.uapInterestedLessonsApplyFilter(filter))
      this.uapInterestedLessonsIsSet = false;

    if (!this.uapInterestedRidesApplyFilter(filter))
      this.uapInterestedRidesIsSet = false;

    if (!this.entityTypeApplyFilter(filter)) this.entityTypeIsSet = false;

    if (!this.jpTeamIdApplyFilter(filter)) this.jpTeamIdIsSet = false;

    if (!this.guestPortalRegApplyFilter(filter))
      this.guestPortalRegIsSet = false;

    if (!this.signoutBlockReasonApplyFilter(filter))
      this.signoutBlockReasonIsSet = false;

    if (!this.campFairApplyFilter(filter)) this.campFairIsSet = false;

    if (!this.dataUnconfirmedApplyFilter(filter))
      this.dataUnconfirmedIsSet = false;

    if (!this.protopersonCookieApplyFilter(filter))
      this.protopersonCookieIsSet = false;

    if (!this.protoStateApplyFilter(filter)) this.protoStateIsSet = false;

    if (!this.memberCommentApplyFilter(filter)) this.memberCommentIsSet = false;

    if (!this.slackUserIdApplyFilter(filter)) this.slackUserIdIsSet = false;

    if (!this.squareCustomerIdApplyFilter(filter))
      this.squareCustomerIdIsSet = false;

    if (!this.defaultCardIdApplyFilter(filter)) this.defaultCardIdIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    if (!this.allowSignoutsApplyFilter(filter)) this.allowSignoutsIsSet = false;

    if (!this.personTypeApplyFilter(filter)) this.personTypeIsSet = false;

    if (!this.allergiesApplyFilter(filter)) this.allergiesIsSet = false;

    if (!this.medicationsApplyFilter(filter)) this.medicationsIsSet = false;

    if (!this.specialNeedsApplyFilter(filter)) this.specialNeedsIsSet = false;

    if (!this.genderApplyFilter(filter)) this.genderIsSet = false;

    if (!this.occupationApplyFilter(filter)) this.occupationIsSet = false;

    if (!this.citizenshipApplyFilter(filter)) this.citizenshipIsSet = false;

    if (!this.ethnicityApplyFilter(filter)) this.ethnicityIsSet = false;

    if (!this.languageApplyFilter(filter)) this.languageIsSet = false;

    if (!this.matchingGiftsApplyFilter(filter)) this.matchingGiftsIsSet = false;

    if (!this.studentApplyFilter(filter)) this.studentIsSet = false;

    if (!this.schoolApplyFilter(filter)) this.schoolIsSet = false;

    if (!this.militaryApplyFilter(filter)) this.militaryIsSet = false;

    if (!this.reducedLunchApplyFilter(filter)) this.reducedLunchIsSet = false;

    if (!this.previousMemberApplyFilter(filter))
      this.previousMemberIsSet = false;

    if (!this.swimProofApplyFilter(filter)) this.swimProofIsSet = false;

    if (!this.dobApplyFilter(filter)) this.dobIsSet = false;

    if (!this.dobVerifiedApplyFilter(filter)) this.dobVerifiedIsSet = false;

    if (!this.stripeCustomerIdApplyFilter(filter))
      this.stripeCustomerIdIsSet = false;

    if (!this.tempApplyFilter(filter)) this.tempIsSet = false;

    if (!this.referralsApplyFilter(filter)) this.referralsIsSet = false;

    this.referrals?.forEach((a) => a.unassignAll(filter));
    if (!this.phonesApplyFilter(filter)) this.phonesIsSet = false;

    this.phones?.forEach((a) => a.unassignAll(filter));
    if (!this.addressesApplyFilter(filter)) this.addressesIsSet = false;

    this.addresses?.forEach((a) => a.unassignAll(filter));
    if (!this.relationsAApplyFilter(filter)) this.relationsAIsSet = false;

    this.relationsA?.forEach((a) => a.unassignAll(filter));
    if (!this.relationsBApplyFilter(filter)) this.relationsBIsSet = false;

    this.relationsB?.forEach((a) => a.unassignAll(filter));
    if (!this.isLockedApplyFilter(filter)) this.isLockedIsSet = false;

    if (!this.currentDamageWaiversApplyFilter(filter))
      this.currentDamageWaiversIsSet = false;

    this.currentDamageWaivers?.forEach((a) => a.unassignAll(filter));
    if (!this.currentMembershipsApplyFilter(filter))
      this.currentMembershipsIsSet = false;

    this.currentMemberships?.forEach((a) => a.unassignAll(filter));
    if (!this.currentCardsApplyFilter(filter)) this.currentCardsIsSet = false;

    this.currentCards?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.updatedOn, PersonDTOMeta, this.updatedOn, this);
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.updatedBy, PersonDTOMeta, this.updatedBy, this);
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.createdOn, PersonDTOMeta, this.createdOn, this);
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.createdBy, PersonDTOMeta, this.createdBy, this);
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  veteranEligibleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.veteranEligible,
      PersonDTOMeta,
      this.veteranEligible,
      this,
    );
  }
  veteranEligibleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.veteranEligibleIsSet && this.veteranEligibleApplyFilter(filter))
      return true;

    return false;
  }
  sailingExpApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.sailingExp,
      PersonDTOMeta,
      this.sailingExp,
      this,
    );
  }
  sailingExpIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sailingExpIsSet && this.sailingExpApplyFilter(filter)) return true;

    return false;
  }
  orgContactApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.orgContact,
      PersonDTOMeta,
      this.orgContact,
      this,
    );
  }
  orgContactIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orgContactIsSet && this.orgContactApplyFilter(filter)) return true;

    return false;
  }
  parentEmailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.parentEmail,
      PersonDTOMeta,
      this.parentEmail,
      this,
    );
  }
  parentEmailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.parentEmailIsSet && this.parentEmailApplyFilter(filter))
      return true;

    return false;
  }
  incomeLevelApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.incomeLevel,
      PersonDTOMeta,
      this.incomeLevel,
      this,
    );
  }
  incomeLevelIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.incomeLevelIsSet && this.incomeLevelApplyFilter(filter))
      return true;

    return false;
  }
  incomeAmtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.incomeAmt, PersonDTOMeta, this.incomeAmt, this);
  }
  incomeAmtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.incomeAmtIsSet && this.incomeAmtApplyFilter(filter)) return true;

    return false;
  }
  incomeAmtRawApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.incomeAmtRaw,
      PersonDTOMeta,
      this.incomeAmtRaw,
      this,
    );
  }
  incomeAmtRawIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.incomeAmtRawIsSet && this.incomeAmtRawApplyFilter(filter))
      return true;

    return false;
  }
  badMailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.badMail, PersonDTOMeta, this.badMail, this);
  }
  badMailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badMailIsSet && this.badMailApplyFilter(filter)) return true;

    return false;
  }
  deceasedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.deceased, PersonDTOMeta, this.deceased, this);
  }
  deceasedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.deceasedIsSet && this.deceasedApplyFilter(filter)) return true;

    return false;
  }
  doNotCallApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.doNotCall, PersonDTOMeta, this.doNotCall, this);
  }
  doNotCallIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotCallIsSet && this.doNotCallApplyFilter(filter)) return true;

    return false;
  }
  doNotEmailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.doNotEmail,
      PersonDTOMeta,
      this.doNotEmail,
      this,
    );
  }
  doNotEmailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotEmailIsSet && this.doNotEmailApplyFilter(filter)) return true;

    return false;
  }
  doNotMailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.doNotMail, PersonDTOMeta, this.doNotMail, this);
  }
  doNotMailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotMailIsSet && this.doNotMailApplyFilter(filter)) return true;

    return false;
  }
  employerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.employer, PersonDTOMeta, this.employer, this);
  }
  employerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.employerIsSet && this.employerApplyFilter(filter)) return true;

    return false;
  }
  referralSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.referralSource,
      PersonDTOMeta,
      this.referralSource,
      this,
    );
  }
  referralSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralSourceIsSet && this.referralSourceApplyFilter(filter))
      return true;

    return false;
  }
  badPhoneApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.badPhone, PersonDTOMeta, this.badPhone, this);
  }
  badPhoneIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badPhoneIsSet && this.badPhoneApplyFilter(filter)) return true;

    return false;
  }
  badEmailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.badEmail, PersonDTOMeta, this.badEmail, this);
  }
  badEmailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badEmailIsSet && this.badEmailApplyFilter(filter)) return true;

    return false;
  }
  referralOtherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.referralOther,
      PersonDTOMeta,
      this.referralOther,
      this,
    );
  }
  referralOtherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralOtherIsSet && this.referralOtherApplyFilter(filter))
      return true;

    return false;
  }
  jpAgeOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.jpAgeOverride,
      PersonDTOMeta,
      this.jpAgeOverride,
      this,
    );
  }
  jpAgeOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.jpAgeOverrideIsSet && this.jpAgeOverrideApplyFilter(filter))
      return true;

    return false;
  }
  sendAlertApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.sendAlert, PersonDTOMeta, this.sendAlert, this);
  }
  sendAlertIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sendAlertIsSet && this.sendAlertApplyFilter(filter)) return true;

    return false;
  }
  ignoreJpMinAgeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.ignoreJpMinAge,
      PersonDTOMeta,
      this.ignoreJpMinAge,
      this,
    );
  }
  ignoreJpMinAgeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ignoreJpMinAgeIsSet && this.ignoreJpMinAgeApplyFilter(filter))
      return true;

    return false;
  }
  uapInterestedLessonsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.uapInterestedLessons,
      PersonDTOMeta,
      this.uapInterestedLessons,
      this,
    );
  }
  uapInterestedLessonsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.uapInterestedLessonsIsSet &&
      this.uapInterestedLessonsApplyFilter(filter)
    )
      return true;

    return false;
  }
  uapInterestedRidesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.uapInterestedRides,
      PersonDTOMeta,
      this.uapInterestedRides,
      this,
    );
  }
  uapInterestedRidesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.uapInterestedRidesIsSet &&
      this.uapInterestedRidesApplyFilter(filter)
    )
      return true;

    return false;
  }
  entityTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.entityType,
      PersonDTOMeta,
      this.entityType,
      this,
    );
  }
  entityTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.entityTypeIsSet && this.entityTypeApplyFilter(filter)) return true;

    return false;
  }
  jpTeamIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.jpTeamId, PersonDTOMeta, this.jpTeamId, this);
  }
  jpTeamIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.jpTeamIdIsSet && this.jpTeamIdApplyFilter(filter)) return true;

    return false;
  }
  guestPortalRegApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.guestPortalReg,
      PersonDTOMeta,
      this.guestPortalReg,
      this,
    );
  }
  guestPortalRegIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.guestPortalRegIsSet && this.guestPortalRegApplyFilter(filter))
      return true;

    return false;
  }
  signoutBlockReasonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.signoutBlockReason,
      PersonDTOMeta,
      this.signoutBlockReason,
      this,
    );
  }
  signoutBlockReasonIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.signoutBlockReasonIsSet &&
      this.signoutBlockReasonApplyFilter(filter)
    )
      return true;

    return false;
  }
  campFairApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.campFair, PersonDTOMeta, this.campFair, this);
  }
  campFairIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.campFairIsSet && this.campFairApplyFilter(filter)) return true;

    return false;
  }
  dataUnconfirmedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.dataUnconfirmed,
      PersonDTOMeta,
      this.dataUnconfirmed,
      this,
    );
  }
  dataUnconfirmedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dataUnconfirmedIsSet && this.dataUnconfirmedApplyFilter(filter))
      return true;

    return false;
  }
  protopersonCookieApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.protopersonCookie,
      PersonDTOMeta,
      this.protopersonCookie,
      this,
    );
  }
  protopersonCookieIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.protopersonCookieIsSet &&
      this.protopersonCookieApplyFilter(filter)
    )
      return true;

    return false;
  }
  protoStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.protoState,
      PersonDTOMeta,
      this.protoState,
      this,
    );
  }
  protoStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.protoStateIsSet && this.protoStateApplyFilter(filter)) return true;

    return false;
  }
  memberCommentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.memberComment,
      PersonDTOMeta,
      this.memberComment,
      this,
    );
  }
  memberCommentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.memberCommentIsSet && this.memberCommentApplyFilter(filter))
      return true;

    return false;
  }
  slackUserIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.slackUserId,
      PersonDTOMeta,
      this.slackUserId,
      this,
    );
  }
  slackUserIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.slackUserIdIsSet && this.slackUserIdApplyFilter(filter))
      return true;

    return false;
  }
  squareCustomerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.squareCustomerId,
      PersonDTOMeta,
      this.squareCustomerId,
      this,
    );
  }
  squareCustomerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareCustomerIdIsSet && this.squareCustomerIdApplyFilter(filter))
      return true;

    return false;
  }
  defaultCardIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.defaultCardId,
      PersonDTOMeta,
      this.defaultCardId,
      this,
    );
  }
  defaultCardIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.defaultCardIdIsSet && this.defaultCardIdApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.isDeleted, PersonDTOMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.isNew, PersonDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.assignId, PersonDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.prefix, PersonDTOMeta, this.prefix, this);
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.first, PersonDTOMeta, this.first, this);
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.middle, PersonDTOMeta, this.middle, this);
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.last, PersonDTOMeta, this.last, this);
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.suffix, PersonDTOMeta, this.suffix, this);
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.preferred, PersonDTOMeta, this.preferred, this);
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.organization,
      PersonDTOMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.email, PersonDTOMeta, this.email, this);
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  allowSignoutsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.allowSignouts,
      PersonDTOMeta,
      this.allowSignouts,
      this,
    );
  }
  allowSignoutsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowSignoutsIsSet && this.allowSignoutsApplyFilter(filter))
      return true;

    return false;
  }
  personTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.personType,
      PersonDTOMeta,
      this.personType,
      this,
    );
  }
  personTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personTypeIsSet && this.personTypeApplyFilter(filter)) return true;

    return false;
  }
  allergiesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.allergies, PersonDTOMeta, this.allergies, this);
  }
  allergiesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allergiesIsSet && this.allergiesApplyFilter(filter)) return true;

    return false;
  }
  medicationsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.medications,
      PersonDTOMeta,
      this.medications,
      this,
    );
  }
  medicationsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.medicationsIsSet && this.medicationsApplyFilter(filter))
      return true;

    return false;
  }
  specialNeedsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.specialNeeds,
      PersonDTOMeta,
      this.specialNeeds,
      this,
    );
  }
  specialNeedsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specialNeedsIsSet && this.specialNeedsApplyFilter(filter))
      return true;

    return false;
  }
  genderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.gender, PersonDTOMeta, this.gender, this);
  }
  genderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.genderIsSet && this.genderApplyFilter(filter)) return true;

    return false;
  }
  occupationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.occupation,
      PersonDTOMeta,
      this.occupation,
      this,
    );
  }
  occupationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.occupationIsSet && this.occupationApplyFilter(filter)) return true;

    return false;
  }
  citizenshipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.citizenship,
      PersonDTOMeta,
      this.citizenship,
      this,
    );
  }
  citizenshipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.citizenshipIsSet && this.citizenshipApplyFilter(filter))
      return true;

    return false;
  }
  ethnicityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.ethnicity, PersonDTOMeta, this.ethnicity, this);
  }
  ethnicityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ethnicityIsSet && this.ethnicityApplyFilter(filter)) return true;

    return false;
  }
  languageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.language, PersonDTOMeta, this.language, this);
  }
  languageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.languageIsSet && this.languageApplyFilter(filter)) return true;

    return false;
  }
  matchingGiftsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.matchingGifts,
      PersonDTOMeta,
      this.matchingGifts,
      this,
    );
  }
  matchingGiftsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.matchingGiftsIsSet && this.matchingGiftsApplyFilter(filter))
      return true;

    return false;
  }
  studentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.student, PersonDTOMeta, this.student, this);
  }
  studentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.studentIsSet && this.studentApplyFilter(filter)) return true;

    return false;
  }
  schoolApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.school, PersonDTOMeta, this.school, this);
  }
  schoolIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.schoolIsSet && this.schoolApplyFilter(filter)) return true;

    return false;
  }
  militaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.military, PersonDTOMeta, this.military, this);
  }
  militaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.militaryIsSet && this.militaryApplyFilter(filter)) return true;

    return false;
  }
  reducedLunchApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.reducedLunch,
      PersonDTOMeta,
      this.reducedLunch,
      this,
    );
  }
  reducedLunchIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reducedLunchIsSet && this.reducedLunchApplyFilter(filter))
      return true;

    return false;
  }
  previousMemberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.previousMember,
      PersonDTOMeta,
      this.previousMember,
      this,
    );
  }
  previousMemberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.previousMemberIsSet && this.previousMemberApplyFilter(filter))
      return true;

    return false;
  }
  swimProofApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.swimProof, PersonDTOMeta, this.swimProof, this);
  }
  swimProofIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.swimProofIsSet && this.swimProofApplyFilter(filter)) return true;

    return false;
  }
  dobApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.dob, PersonDTOMeta, this.dob, this);
  }
  dobIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dobIsSet && this.dobApplyFilter(filter)) return true;

    return false;
  }
  dobVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.dobVerified,
      PersonDTOMeta,
      this.dobVerified,
      this,
    );
  }
  dobVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dobVerifiedIsSet && this.dobVerifiedApplyFilter(filter))
      return true;

    return false;
  }
  stripeCustomerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.stripeCustomerId,
      PersonDTOMeta,
      this.stripeCustomerId,
      this,
    );
  }
  stripeCustomerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stripeCustomerIdIsSet && this.stripeCustomerIdApplyFilter(filter))
      return true;

    return false;
  }
  tempApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.temp, PersonDTOMeta, this.temp, this);
  }
  tempIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIsSet && this.tempApplyFilter(filter)) return true;

    return false;
  }
  referralsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.referrals, PersonDTOMeta, this.referrals, this);
  }
  referralsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralsIsSet && this.referralsApplyFilter(filter)) return true;

    return this.referrals?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  phonesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.phones, PersonDTOMeta, this.phones, this);
  }
  phonesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.phonesIsSet && this.phonesApplyFilter(filter)) return true;

    return this.phones?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  addressesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.addresses, PersonDTOMeta, this.addresses, this);
  }
  addressesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.addressesIsSet && this.addressesApplyFilter(filter)) return true;

    return this.addresses?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  relationsAApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.relationsA,
      PersonDTOMeta,
      this.relationsA,
      this,
    );
  }
  relationsAIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationsAIsSet && this.relationsAApplyFilter(filter)) return true;

    return this.relationsA?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  relationsBApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.relationsB,
      PersonDTOMeta,
      this.relationsB,
      this,
    );
  }
  relationsBIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationsBIsSet && this.relationsBApplyFilter(filter)) return true;

    return this.relationsB?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  isLockedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonDTOMeta.isLocked, PersonDTOMeta, this.isLocked, this);
  }
  isLockedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isLockedIsSet && this.isLockedApplyFilter(filter)) return true;

    return false;
  }
  currentDamageWaiversApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.currentDamageWaivers,
      PersonDTOMeta,
      this.currentDamageWaivers,
      this,
    );
  }
  currentDamageWaiversIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentDamageWaiversIsSet &&
      this.currentDamageWaiversApplyFilter(filter)
    )
      return true;

    return (
      this.currentDamageWaivers?.find((a) => a.anySet(filter)) != undefined
    );
    return false;
  }
  currentMembershipsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.currentMemberships,
      PersonDTOMeta,
      this.currentMemberships,
      this,
    );
  }
  currentMembershipsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentMembershipsIsSet &&
      this.currentMembershipsApplyFilter(filter)
    )
      return true;

    return this.currentMemberships?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  currentCardsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonDTOMeta.currentCards,
      PersonDTOMeta,
      this.currentCards,
      this,
    );
  }
  currentCardsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.currentCardsIsSet && this.currentCardsApplyFilter(filter))
      return true;

    return this.currentCards?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.veteranEligibleIsSetDeep(filter)) return true;
    if (this.sailingExpIsSetDeep(filter)) return true;
    if (this.orgContactIsSetDeep(filter)) return true;
    if (this.parentEmailIsSetDeep(filter)) return true;
    if (this.incomeLevelIsSetDeep(filter)) return true;
    if (this.incomeAmtIsSetDeep(filter)) return true;
    if (this.incomeAmtRawIsSetDeep(filter)) return true;
    if (this.badMailIsSetDeep(filter)) return true;
    if (this.deceasedIsSetDeep(filter)) return true;
    if (this.doNotCallIsSetDeep(filter)) return true;
    if (this.doNotEmailIsSetDeep(filter)) return true;
    if (this.doNotMailIsSetDeep(filter)) return true;
    if (this.employerIsSetDeep(filter)) return true;
    if (this.referralSourceIsSetDeep(filter)) return true;
    if (this.badPhoneIsSetDeep(filter)) return true;
    if (this.badEmailIsSetDeep(filter)) return true;
    if (this.referralOtherIsSetDeep(filter)) return true;
    if (this.jpAgeOverrideIsSetDeep(filter)) return true;
    if (this.sendAlertIsSetDeep(filter)) return true;
    if (this.ignoreJpMinAgeIsSetDeep(filter)) return true;
    if (this.uapInterestedLessonsIsSetDeep(filter)) return true;
    if (this.uapInterestedRidesIsSetDeep(filter)) return true;
    if (this.entityTypeIsSetDeep(filter)) return true;
    if (this.jpTeamIdIsSetDeep(filter)) return true;
    if (this.guestPortalRegIsSetDeep(filter)) return true;
    if (this.signoutBlockReasonIsSetDeep(filter)) return true;
    if (this.campFairIsSetDeep(filter)) return true;
    if (this.dataUnconfirmedIsSetDeep(filter)) return true;
    if (this.protopersonCookieIsSetDeep(filter)) return true;
    if (this.protoStateIsSetDeep(filter)) return true;
    if (this.memberCommentIsSetDeep(filter)) return true;
    if (this.slackUserIdIsSetDeep(filter)) return true;
    if (this.squareCustomerIdIsSetDeep(filter)) return true;
    if (this.defaultCardIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    if (this.allowSignoutsIsSetDeep(filter)) return true;
    if (this.personTypeIsSetDeep(filter)) return true;
    if (this.allergiesIsSetDeep(filter)) return true;
    if (this.medicationsIsSetDeep(filter)) return true;
    if (this.specialNeedsIsSetDeep(filter)) return true;
    if (this.genderIsSetDeep(filter)) return true;
    if (this.occupationIsSetDeep(filter)) return true;
    if (this.citizenshipIsSetDeep(filter)) return true;
    if (this.ethnicityIsSetDeep(filter)) return true;
    if (this.languageIsSetDeep(filter)) return true;
    if (this.matchingGiftsIsSetDeep(filter)) return true;
    if (this.studentIsSetDeep(filter)) return true;
    if (this.schoolIsSetDeep(filter)) return true;
    if (this.militaryIsSetDeep(filter)) return true;
    if (this.reducedLunchIsSetDeep(filter)) return true;
    if (this.previousMemberIsSetDeep(filter)) return true;
    if (this.swimProofIsSetDeep(filter)) return true;
    if (this.dobIsSetDeep(filter)) return true;
    if (this.dobVerifiedIsSetDeep(filter)) return true;
    if (this.stripeCustomerIdIsSetDeep(filter)) return true;
    if (this.tempIsSetDeep(filter)) return true;
    if (this.referralsIsSetDeep(filter)) return true;
    if (this.phonesIsSetDeep(filter)) return true;
    if (this.addressesIsSetDeep(filter)) return true;
    if (this.relationsAIsSetDeep(filter)) return true;
    if (this.relationsBIsSetDeep(filter)) return true;
    if (this.isLockedIsSetDeep(filter)) return true;
    if (this.currentDamageWaiversIsSetDeep(filter)) return true;
    if (this.currentMembershipsIsSetDeep(filter)) return true;
    if (this.currentCardsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
